import { AlertStatus } from '@/entities/alert-status';
import type { Asset } from '@/siteview/entities/asset';
import { AssetType } from '@/siteview/entities/asset-type';

export const data: Record<string, Asset[]> = {
  '12345': [
    {
      id: '1234501',
      type: AssetType.PCS,
      frontendId: '',
      fullFrontendId: 'Country_Corner/PCS_01',
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {},
    },
    {
      id: '1234502',
      type: AssetType.PCS,
      frontendId: '',
      fullFrontendId: 'Country_Corner/PCS_02',
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {},
    },
    {
      id: '1234503',
      type: AssetType.PCS,
      frontendId: '',
      fullFrontendId: 'Country_Corner/PCS_03',
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {},
    },
    {
      id: '1234504',
      type: AssetType.PCS,
      frontendId: '',
      fullFrontendId: 'Country_Corner/PCS_04',
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {},
    },
    {
      id: '1234505',
      type: AssetType.PCS,
      frontendId: '',
      fullFrontendId: 'Country_Corner/PCS_05',
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {},
    },
    {
      id: '1234506',
      type: AssetType.PCS,
      frontendId: '',
      fullFrontendId: 'Country_Corner/PCS_06',
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {},
    },
    {
      id: '1234507',
      type: AssetType.PCS,
      frontendId: '',
      fullFrontendId: 'Country_Corner/PCS_07',
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {},
    },
    {
      id: '1234508',
      type: AssetType.PCS,
      frontendId: '',
      fullFrontendId: 'Country_Corner/PCS_08',
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {},
    },
    {
      id: '1234509',
      type: AssetType.PCS,
      frontendId: '',
      fullFrontendId: 'Country_Corner/PCS_09',
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {},
    },
    {
      id: '1234510',
      type: AssetType.PCS,
      frontendId: '',
      fullFrontendId: 'Country_Corner/PCS_10',
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {},
    },
    {
      id: '1234511',
      type: AssetType.PCS,
      frontendId: '',
      fullFrontendId: 'Country_Corner/PCS_11',
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {},
    },
    {
      id: '1234512',
      type: AssetType.PCS,
      frontendId: '',
      fullFrontendId: 'Country_Corner/PCS_12',
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {},
    },
    {
      id: '1234513',
      type: AssetType.PCS,
      frontendId: '',
      fullFrontendId: 'Country_Corner/PCS_13',
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {},
    },
    {
      id: '1234514',
      type: AssetType.PCS,
      frontendId: '',
      fullFrontendId: 'Country_Corner/PCS_14',
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {},
    },
    {
      id: '1234515',
      type: AssetType.PCS,
      frontendId: '',
      fullFrontendId: 'Country_Corner/PCS_15',
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {},
    },
    {
      id: '1234516',
      type: AssetType.PCS,
      frontendId: '',
      fullFrontendId: 'Country_Corner/PCS_16',
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {},
    },
    {
      id: '1234517',
      type: AssetType.PCS,
      frontendId: '',
      fullFrontendId: 'Country_Corner/PCS_17',
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {},
    },
    {
      id: '1234518',
      type: AssetType.PCS,
      frontendId: '',
      fullFrontendId: 'Country_Corner/PCS_18',
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {},
    },
    {
      id: '1234519',
      type: AssetType.PCS,
      frontendId: '',
      fullFrontendId: 'Country_Corner/PCS_19',
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {},
    },
    {
      id: '1234520',
      type: AssetType.PCS,
      frontendId: '',
      fullFrontendId: 'Country_Corner/PCS_20',
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {},
    },
    {
      id: '1234521',
      type: AssetType.PCS,
      frontendId: '',
      fullFrontendId: 'Country_Corner/PCS_21',
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {},
    },
    {
      id: '1234522',
      type: AssetType.PCS,
      frontendId: '',
      fullFrontendId: 'Country_Corner/PCS_22',
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {},
    },
    {
      id: '1234523',
      type: AssetType.PCS,
      frontendId: '',
      fullFrontendId: 'Country_Corner/PCS_23',
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {},
    },
    {
      id: '1234524',
      type: AssetType.PCS,
      frontendId: '',
      fullFrontendId: 'Country_Corner/PCS_24',
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {},
    },
    {
      id: '1234525',
      type: AssetType.PCS,
      frontendId: '',
      fullFrontendId: 'Country_Corner/PCS_25',
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {},
    },
    {
      id: '1234526',
      type: AssetType.PCS,
      frontendId: '',
      fullFrontendId: 'Country_Corner/PCS_26',
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {},
    },
    {
      id: '1234527',
      type: AssetType.PCS,
      frontendId: '',
      fullFrontendId: 'Country_Corner/PCS_27',
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {},
    },
    {
      id: '1234528',
      type: AssetType.PCS,
      frontendId: '',
      fullFrontendId: 'Country_Corner/PCS_28',
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {},
    },
    {
      id: '1234529',
      type: AssetType.PCS,
      frontendId: '',
      fullFrontendId: 'Country_Corner/PCS_29',
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {},
    },
    {
      id: '1234530',
      type: AssetType.PCS,
      frontendId: '',
      fullFrontendId: 'Country_Corner/PCS_30',
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {},
    },
    {
      id: '1234531',
      type: AssetType.PCS,
      frontendId: '',
      fullFrontendId: 'Country_Corner/PCS_31',
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {},
    },
    {
      id: '9739835394366000',
      type: AssetType.CONTAINER,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B01',
      accureSoc: 0.440313581,
      bmsSoc: 0.5183112400000001,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '18510550128694977',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B01/Rack_01',
      accureSoc: 0.5029714599999999,
      bmsSoc: 0.56998722,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '20549422368304181',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B01/Rack_02',
      accureSoc: 0.39692413000000004,
      bmsSoc: 0.43831955,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '67208029915131260',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B01/Rack_03',
      accureSoc: 0.39325306,
      bmsSoc: 0.5248037,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '27545060227891593',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B01/Rack_04',
      accureSoc: 0.46131542000000003,
      bmsSoc: 0.5565836000000001,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '60601306731649707',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B01/Rack_05',
      accureSoc: 0.48167026999999996,
      bmsSoc: 0.5288071999999999,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '63123832139559368',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B01/Rack_06',
      accureSoc: 0.47549280000000005,
      bmsSoc: 0.4449927,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '41944926425762964',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B01/Rack_07',
      accureSoc: 0.44825085000000003,
      bmsSoc: 0.5646863599999999,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '24405506703844224',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B01/Rack_08',
      accureSoc: 0.45476419999999995,
      bmsSoc: 0.49592113,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '42272127689711786',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B01/Rack_09',
      accureSoc: 0.40246567,
      bmsSoc: 0.52541344,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '6471416015895949',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B01/Rack_10',
      accureSoc: 0.38602795,
      bmsSoc: 0.5335975,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '14115102612756205',
      type: AssetType.CONTAINER,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B02',
      accureSoc: 0.44487072800000005,
      bmsSoc: 0.508844371,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '53412654243085819',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B02/Rack_01',
      accureSoc: 0.5129974399999999,
      bmsSoc: 0.5452641,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '41132362186614864',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B02/Rack_02',
      accureSoc: 0.44611649999999997,
      bmsSoc: 0.5774869499999999,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '200804506794335',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B02/Rack_03',
      accureSoc: 0.50168385,
      bmsSoc: 0.55089596,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '3005189968530496',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B02/Rack_04',
      accureSoc: 0.41730544999999997,
      bmsSoc: 0.507209,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '22183080308027674',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B02/Rack_05',
      accureSoc: 0.44758876999999997,
      bmsSoc: 0.43981052,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '33153032122014401',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B02/Rack_06',
      accureSoc: 0.48905758,
      bmsSoc: 0.52772728,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '11384857325292251',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B02/Rack_07',
      accureSoc: 0.38675137,
      bmsSoc: 0.4620671,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '53702617871982399',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B02/Rack_08',
      accureSoc: 0.45108307000000003,
      bmsSoc: 0.49335270000000003,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '43313190410857714',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B02/Rack_09',
      accureSoc: 0.42624775,
      bmsSoc: 0.41605849999999994,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '49587895811009218',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B02/Rack_10',
      accureSoc: 0.36987549999999997,
      bmsSoc: 0.5685716,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '65852267895348562',
      type: AssetType.CONTAINER,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B03',
      accureSoc: 0.425943553,
      bmsSoc: 0.5028893860000001,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '49243845264996471',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B03/Rack_01',
      accureSoc: 0.42815712,
      bmsSoc: 0.4997685,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '47799741924237567',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B03/Rack_02',
      accureSoc: 0.44889539999999994,
      bmsSoc: 0.54935814,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '19546148844086505',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B03/Rack_03',
      accureSoc: 0.4230612,
      bmsSoc: 0.5305847,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '12413274228929202',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B03/Rack_04',
      accureSoc: 0.38258380000000003,
      bmsSoc: 0.40192608,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '10193385709592867',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B03/Rack_05',
      accureSoc: 0.41496837999999997,
      bmsSoc: 0.55333893,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '27325543801546025',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B03/Rack_06',
      accureSoc: 0.44098633,
      bmsSoc: 0.5826821,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '25491175176508835',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B03/Rack_07',
      accureSoc: 0.37969982,
      bmsSoc: 0.49106037,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '50385604783138722',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B03/Rack_08',
      accureSoc: 0.48035269999999997,
      bmsSoc: 0.41105606,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '33421511769530802',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B03/Rack_09',
      accureSoc: 0.45547684,
      bmsSoc: 0.5141378799999999,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '29970670436018244',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B03/Rack_10',
      accureSoc: 0.40525394,
      bmsSoc: 0.49498109999999995,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '32524247218213010',
      type: AssetType.CONTAINER,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B04',
      accureSoc: 0.44767713400000003,
      bmsSoc: 0.51131858,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '11057815505330630',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B04/Rack_01',
      accureSoc: 0.39606087,
      bmsSoc: 0.53477528,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '9964012301718093',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B04/Rack_02',
      accureSoc: 0.43239162,
      bmsSoc: 0.58386044,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '68692154953849428',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B04/Rack_03',
      accureSoc: 0.3747323,
      bmsSoc: 0.548639,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '27864213323333659',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B04/Rack_04',
      accureSoc: 0.49858020000000003,
      bmsSoc: 0.42333339999999997,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '2251106242537921',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B04/Rack_05',
      accureSoc: 0.4680377,
      bmsSoc: 0.54134186,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '42230967664824705',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B04/Rack_06',
      accureSoc: 0.49567566,
      bmsSoc: 0.54169117,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '32398600054135596',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B04/Rack_07',
      accureSoc: 0.43478245,
      bmsSoc: 0.413103,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '32228836347571270',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B04/Rack_08',
      accureSoc: 0.44139297,
      bmsSoc: 0.50071136,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '43743256505231184',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B04/Rack_09',
      accureSoc: 0.43562733000000003,
      bmsSoc: 0.52664593,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '50371792209163583',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B04/Rack_10',
      accureSoc: 0.49949024000000003,
      bmsSoc: 0.49908436,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '15142662163423298',
      type: AssetType.CONTAINER,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B05',
      accureSoc: 0.45236170000000003,
      bmsSoc: 0.49618789899999993,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '25873446975477286',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B05/Rack_01',
      accureSoc: 0.51321938,
      bmsSoc: 0.56818016,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '15324756511501699',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B05/Rack_02',
      accureSoc: 0.41699715,
      bmsSoc: 0.44370487,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '12842385906561425',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B05/Rack_03',
      accureSoc: 0.48456794999999997,
      bmsSoc: 0.5409614,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '6754493798219001',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B05/Rack_04',
      accureSoc: 0.45414307,
      bmsSoc: 0.44518955,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '46986623740661229',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B05/Rack_05',
      accureSoc: 0.43874554000000004,
      bmsSoc: 0.5710647999999999,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '34451422262265380',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B05/Rack_06',
      accureSoc: 0.45918247,
      bmsSoc: 0.461842,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '51228206435257463',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B05/Rack_07',
      accureSoc: 0.4280259,
      bmsSoc: 0.4631557,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '60935478022470524',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B05/Rack_08',
      accureSoc: 0.49618435,
      bmsSoc: 0.4488566,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '47899254095945171',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B05/Rack_09',
      accureSoc: 0.40710884,
      bmsSoc: 0.46813057,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '41766947065356657',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B05/Rack_10',
      accureSoc: 0.42544235,
      bmsSoc: 0.55079334,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '18544298069061869',
      type: AssetType.CONTAINER,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B06',
      accureSoc: 0.425262282,
      bmsSoc: 0.508117573,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '5989054454777011',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B06/Rack_01',
      accureSoc: 0.5121117000000001,
      bmsSoc: 0.5846125,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '61595418260241589',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B06/Rack_02',
      accureSoc: 0.50078423,
      bmsSoc: 0.4257512,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '31987574562642903',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B06/Rack_03',
      accureSoc: 0.43866257,
      bmsSoc: 0.46513664,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '12499268189333681',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B06/Rack_04',
      accureSoc: 0.4124819,
      bmsSoc: 0.43944138000000005,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '34272712166528836',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B06/Rack_05',
      accureSoc: 0.35172356,
      bmsSoc: 0.49442272000000004,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '53228867100884859',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B06/Rack_06',
      accureSoc: 0.39153087999999997,
      bmsSoc: 0.5409153,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '52439835487991639',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B06/Rack_07',
      accureSoc: 0.35118473,
      bmsSoc: 0.5378858000000001,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '52458105774515491',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B06/Rack_08',
      accureSoc: 0.41138171999999995,
      bmsSoc: 0.58340485,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '15939649511646368',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B06/Rack_09',
      accureSoc: 0.38331726000000005,
      bmsSoc: 0.48443134,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '18133567724010800',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B06/Rack_10',
      accureSoc: 0.49944426999999997,
      bmsSoc: 0.525174,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '66868980844720849',
      type: AssetType.CONTAINER,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B07',
      accureSoc: 0.44200114399999996,
      bmsSoc: 0.49663110600000004,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '9989473834664962',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B07/Rack_01',
      accureSoc: 0.50872818,
      bmsSoc: 0.5651465600000001,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '69618346777589466',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B07/Rack_02',
      accureSoc: 0.37077538,
      bmsSoc: 0.3986735,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '14128602983920693',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B07/Rack_03',
      accureSoc: 0.49521984,
      bmsSoc: 0.5372004,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '32892454087772485',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B07/Rack_04',
      accureSoc: 0.38465491999999996,
      bmsSoc: 0.537489,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '63377333619320009',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B07/Rack_05',
      accureSoc: 0.50009033,
      bmsSoc: 0.4153611,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '35260018520653022',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B07/Rack_06',
      accureSoc: 0.37046394,
      bmsSoc: 0.55520348,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '3665309423788960',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B07/Rack_07',
      accureSoc: 0.37485172,
      bmsSoc: 0.57271904,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '15352581004808595',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B07/Rack_08',
      accureSoc: 0.50337273,
      bmsSoc: 0.41086803000000005,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '35916998317933242',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B07/Rack_09',
      accureSoc: 0.4828972,
      bmsSoc: 0.4545152,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '32872391906993377',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B07/Rack_10',
      accureSoc: 0.4289572,
      bmsSoc: 0.51913475,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '47756555087370039',
      type: AssetType.CONTAINER,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B08',
      accureSoc: 0.465702414,
      bmsSoc: 0.520613058,
      alertStatus: AlertStatus.WARNING,
      nbOpenTasks: 1,
      metadata: {
        capacity: 1000000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '64544906727223905',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B08/Rack_01',
      accureSoc: 0.5111822,
      bmsSoc: 0.5546791,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '23152343014322097',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B08/Rack_02',
      accureSoc: 0.49788780000000005,
      bmsSoc: 0.5081543,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '3509739286086225',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B08/Rack_03',
      accureSoc: 0.37220673,
      bmsSoc: 0.57616276,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '13317774037895696',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B08/Rack_04',
      accureSoc: 0.43433315,
      bmsSoc: 0.46165737,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '57506560893055939',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B08/Rack_05',
      accureSoc: 0.47007675,
      bmsSoc: 0.52916737,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '54611592107022391',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B08/Rack_06',
      accureSoc: 0.48836863999999996,
      bmsSoc: 0.48494526,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '68194431705816823',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B08/Rack_07',
      accureSoc: 0.43718395,
      bmsSoc: 0.4859836,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '65342725437198548',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B08/Rack_08',
      accureSoc: 0.5145550999999999,
      bmsSoc: 0.5838739000000001,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '8973983127750483',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B08/Rack_09',
      accureSoc: 0.41635277000000004,
      bmsSoc: 0.54334297,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '9163541306821944',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B08/Rack_10',
      accureSoc: 0.51487705,
      bmsSoc: 0.47816395,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '48132666588666541',
      type: AssetType.CONTAINER,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B09',
      accureSoc: 0.412552357,
      bmsSoc: 0.5159749849999999,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '61004656969650268',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B09/Rack_01',
      accureSoc: 0.39792274,
      bmsSoc: 0.51769424,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '32584793640122762',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B09/Rack_02',
      accureSoc: 0.40825226000000003,
      bmsSoc: 0.4563236,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '59449140925314565',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B09/Rack_03',
      accureSoc: 0.36681416,
      bmsSoc: 0.58626495,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '68920896432152338',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B09/Rack_04',
      accureSoc: 0.43738922,
      bmsSoc: 0.5394229500000001,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '46790268423753599',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B09/Rack_05',
      accureSoc: 0.48220782999999995,
      bmsSoc: 0.4181307,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '37874475004350576',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B09/Rack_06',
      accureSoc: 0.43853798,
      bmsSoc: 0.54154236,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '2958847841157008',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B09/Rack_07',
      accureSoc: 0.43671177,
      bmsSoc: 0.49001358000000006,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '26350145115484613',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B09/Rack_08',
      accureSoc: 0.38172809999999996,
      bmsSoc: 0.4570864,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '32718999393037227',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B09/Rack_09',
      accureSoc: 0.40583637000000006,
      bmsSoc: 0.58609837,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '50677494698974635',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B09/Rack_10',
      accureSoc: 0.37012314,
      bmsSoc: 0.5671727,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '17871600849759120',
      type: AssetType.CONTAINER,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B10',
      accureSoc: 0.45312628000000005,
      bmsSoc: 0.4821675749999999,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '785503921293096',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B10/Rack_01',
      accureSoc: 0.5007168200000001,
      bmsSoc: 0.44119038000000005,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '24203669966234050',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B10/Rack_02',
      accureSoc: 0.43477980000000005,
      bmsSoc: 0.4647444,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '25429773579953858',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B10/Rack_03',
      accureSoc: 0.447907,
      bmsSoc: 0.47318558000000005,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '32656801140191935',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B10/Rack_04',
      accureSoc: 0.41612694,
      bmsSoc: 0.4013212,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '33086645431136950',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B10/Rack_05',
      accureSoc: 0.49592396,
      bmsSoc: 0.39868454,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '44821244190917697',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B10/Rack_06',
      accureSoc: 0.50026745,
      bmsSoc: 0.51765152,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '15751082509800804',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B10/Rack_07',
      accureSoc: 0.49830517,
      bmsSoc: 0.46160989999999996,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '14178622165374584',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B10/Rack_08',
      accureSoc: 0.4624912,
      bmsSoc: 0.57926296,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '17881726359928172',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B10/Rack_09',
      accureSoc: 0.41278709999999996,
      bmsSoc: 0.53712364,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '32809988975118168',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B10/Rack_10',
      accureSoc: 0.36195735999999995,
      bmsSoc: 0.54690163,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '56724886883381766',
      type: AssetType.CONTAINER,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B11',
      accureSoc: 0.38266574299999995,
      bmsSoc: 0.49082325799999993,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '23323314879478550',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B11/Rack_01',
      accureSoc: 0.35962482,
      bmsSoc: 0.5517383,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '61365916912849309',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B11/Rack_02',
      accureSoc: 0.36764569999999996,
      bmsSoc: 0.56275635,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '23468523451455008',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B11/Rack_03',
      accureSoc: 0.37772883999999995,
      bmsSoc: 0.4969222,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '829221139101683',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B11/Rack_04',
      accureSoc: 0.3548166,
      bmsSoc: 0.44182602000000004,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '8614138290846856',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B11/Rack_05',
      accureSoc: 0.36333416,
      bmsSoc: 0.51412746,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '48818031772887542',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B11/Rack_06',
      accureSoc: 0.45622883000000003,
      bmsSoc: 0.5194822,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '20465382959444694',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B11/Rack_07',
      accureSoc: 0.39432293,
      bmsSoc: 0.39532066,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '7332170133676183',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B11/Rack_08',
      accureSoc: 0.36383625,
      bmsSoc: 0.43933678,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '67551768505398407',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B11/Rack_09',
      accureSoc: 0.39417304999999997,
      bmsSoc: 0.48869637,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '21073265830312646',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B11/Rack_10',
      accureSoc: 0.39494625,
      bmsSoc: 0.49802624,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '23128282883536391',
      type: AssetType.CONTAINER,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B12',
      accureSoc: 0.41008909000000004,
      bmsSoc: 0.455020054,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '18012315565896238',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B12/Rack_01',
      accureSoc: 0.38014378,
      bmsSoc: 0.5004713000000001,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '4096745221330263',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B12/Rack_02',
      accureSoc: 0.41139088,
      bmsSoc: 0.41274227,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '14939940098146335',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B12/Rack_03',
      accureSoc: 0.44390793,
      bmsSoc: 0.44496098000000006,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '43096600658243782',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B12/Rack_04',
      accureSoc: 0.5039343000000001,
      bmsSoc: 0.39466693999999997,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '46968088649331818',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B12/Rack_05',
      accureSoc: 0.41134674,
      bmsSoc: 0.40504112,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '6056484481157065',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B12/Rack_06',
      accureSoc: 0.3522012,
      bmsSoc: 0.520976,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '5593354097500761',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B12/Rack_07',
      accureSoc: 0.38699184000000003,
      bmsSoc: 0.5614418,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '11827113576427829',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B12/Rack_08',
      accureSoc: 0.40449126999999996,
      bmsSoc: 0.47954673999999997,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '69727619634080034',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B12/Rack_09',
      accureSoc: 0.38425274000000004,
      bmsSoc: 0.40584826999999996,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '15219950701611155',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B12/Rack_10',
      accureSoc: 0.42223022,
      bmsSoc: 0.42450512,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '69536875005703131',
      type: AssetType.CONTAINER,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B13',
      accureSoc: 0.452747397,
      bmsSoc: 0.468203422,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '46452454989978560',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B13/Rack_01',
      accureSoc: 0.45979523,
      bmsSoc: 0.5696999699999999,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '69006296838680225',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B13/Rack_02',
      accureSoc: 0.40925182,
      bmsSoc: 0.42600586,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '63998850703293741',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B13/Rack_03',
      accureSoc: 0.49793903,
      bmsSoc: 0.4539186,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '46949240297145001',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B13/Rack_04',
      accureSoc: 0.42449875,
      bmsSoc: 0.44774952,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '399911267441666',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B13/Rack_05',
      accureSoc: 0.43586379999999997,
      bmsSoc: 0.49351269999999997,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '48619095513868517',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B13/Rack_06',
      accureSoc: 0.5010395400000001,
      bmsSoc: 0.45915855,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '34768599284165404',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B13/Rack_07',
      accureSoc: 0.35054325,
      bmsSoc: 0.48896999999999996,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '56653590783418914',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B13/Rack_08',
      accureSoc: 0.43622954999999997,
      bmsSoc: 0.44148594,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '69842489705839361',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B13/Rack_09',
      accureSoc: 0.51835262,
      bmsSoc: 0.4387041,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '57550393130509657',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B13/Rack_10',
      accureSoc: 0.49396038,
      bmsSoc: 0.46282898000000006,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '41441766571723748',
      type: AssetType.CONTAINER,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B14',
      accureSoc: 0.43672922299999994,
      bmsSoc: 0.472868276,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '45297514382031054',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B14/Rack_01',
      accureSoc: 0.466868,
      bmsSoc: 0.46568244999999997,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '62503218827957649',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B14/Rack_02',
      accureSoc: 0.41265038,
      bmsSoc: 0.5241367,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '29245221879371902',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B14/Rack_03',
      accureSoc: 0.4440509,
      bmsSoc: 0.46186405,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '2050947959828042',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B14/Rack_04',
      accureSoc: 0.3715424,
      bmsSoc: 0.49737885,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '67770605905027679',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B14/Rack_05',
      accureSoc: 0.36933010000000005,
      bmsSoc: 0.48533572999999997,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '25632963672790656',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B14/Rack_06',
      accureSoc: 0.4472992,
      bmsSoc: 0.40035866,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '25111777456411057',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B14/Rack_07',
      accureSoc: 0.51848255,
      bmsSoc: 0.51640854,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '776486031583367',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B14/Rack_08',
      accureSoc: 0.4176085,
      bmsSoc: 0.4442508,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '9185293464686176',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B14/Rack_09',
      accureSoc: 0.4013628,
      bmsSoc: 0.428838,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '20307605857058898',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B14/Rack_10',
      accureSoc: 0.5180973999999999,
      bmsSoc: 0.50442898,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '60754690120106369',
      type: AssetType.CONTAINER,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B15',
      accureSoc: 0.43370622899999994,
      bmsSoc: 0.479520011,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '53051536248505854',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B15/Rack_01',
      accureSoc: 0.37352577,
      bmsSoc: 0.49040337,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '16613706757810192',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B15/Rack_02',
      accureSoc: 0.5241165999999999,
      bmsSoc: 0.42181080000000004,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '62620663632847641',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B15/Rack_03',
      accureSoc: 0.4204792,
      bmsSoc: 0.47265476,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '10689697607974890',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B15/Rack_04',
      accureSoc: 0.3971653,
      bmsSoc: 0.50440468,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '55330563590153514',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B15/Rack_05',
      accureSoc: 0.42549377,
      bmsSoc: 0.48601536,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '9700019772627367',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B15/Rack_06',
      accureSoc: 0.5012514,
      bmsSoc: 0.41227820000000004,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '70032675825587218',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B15/Rack_07',
      accureSoc: 0.47032825,
      bmsSoc: 0.51370106,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '2116836727674663',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B15/Rack_08',
      accureSoc: 0.46714523,
      bmsSoc: 0.49615948000000004,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '18915650254211359',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B15/Rack_09',
      accureSoc: 0.38777607000000003,
      bmsSoc: 0.4299115,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '64661473704722937',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B15/Rack_10',
      accureSoc: 0.3697807,
      bmsSoc: 0.5678609,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '9542469758485020',
      type: AssetType.CONTAINER,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B16',
      accureSoc: 0.441920654,
      bmsSoc: 0.48379548899999997,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '49108634764414873',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B16/Rack_01',
      accureSoc: 0.39237793000000004,
      bmsSoc: 0.48979120000000004,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '35889711615253138',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B16/Rack_02',
      accureSoc: 0.4859174,
      bmsSoc: 0.4383881,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '12413331974127915',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B16/Rack_03',
      accureSoc: 0.44326572,
      bmsSoc: 0.5162692,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '67830636093593716',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B16/Rack_04',
      accureSoc: 0.4941613,
      bmsSoc: 0.4664219,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '18592466168668586',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B16/Rack_05',
      accureSoc: 0.38457012,
      bmsSoc: 0.44401676,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '17858253888497353',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B16/Rack_06',
      accureSoc: 0.43408875,
      bmsSoc: 0.5092494599999999,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '71012265472545572',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B16/Rack_07',
      accureSoc: 0.3886016,
      bmsSoc: 0.4012211,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '14465267306586943',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B16/Rack_08',
      accureSoc: 0.46727486,
      bmsSoc: 0.54636692,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '30706446729201059',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B16/Rack_09',
      accureSoc: 0.49669266,
      bmsSoc: 0.5570736000000001,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '4820068605217853',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B16/Rack_10',
      accureSoc: 0.4322562,
      bmsSoc: 0.46915664999999995,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '15656191718307884',
      type: AssetType.CONTAINER,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B17',
      accureSoc: 0.47020815400000004,
      bmsSoc: 0.496852435,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '52142253395025605',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B17/Rack_01',
      accureSoc: 0.48518738,
      bmsSoc: 0.48275913000000004,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '20333699900798398',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B17/Rack_02',
      accureSoc: 0.5151254000000001,
      bmsSoc: 0.39380608,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '61698682213406551',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B17/Rack_03',
      accureSoc: 0.5028090000000001,
      bmsSoc: 0.50229397,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '22258116000080408',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B17/Rack_04',
      accureSoc: 0.45767483,
      bmsSoc: 0.45094055,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '2687068079496498',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B17/Rack_05',
      accureSoc: 0.48337432999999996,
      bmsSoc: 0.51438705,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '4090001669242293',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B17/Rack_06',
      accureSoc: 0.44194294,
      bmsSoc: 0.55061897,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '21750137908642234',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B17/Rack_07',
      accureSoc: 0.5230258,
      bmsSoc: 0.5655984000000001,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '7497721837416599',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B17/Rack_08',
      accureSoc: 0.43550804,
      bmsSoc: 0.5252536,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '67536427088638350',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B17/Rack_09',
      accureSoc: 0.36616512,
      bmsSoc: 0.56848965,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '56988802654745276',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B17/Rack_10',
      accureSoc: 0.49126869999999995,
      bmsSoc: 0.41437694999999997,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '62043061842966335',
      type: AssetType.CONTAINER,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B18',
      accureSoc: 0.44674394700000003,
      bmsSoc: 0.516887081,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '70853358094367588',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B18/Rack_01',
      accureSoc: 0.48342860000000004,
      bmsSoc: 0.55019073,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '22159651839929015',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B18/Rack_02',
      accureSoc: 0.39168959999999997,
      bmsSoc: 0.47474842,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '61807720426445642',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B18/Rack_03',
      accureSoc: 0.37428413,
      bmsSoc: 0.44746544,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '41149068504866849',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B18/Rack_04',
      accureSoc: 0.4562188,
      bmsSoc: 0.57233555,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '35872618282645831',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B18/Rack_05',
      accureSoc: 0.45233578,
      bmsSoc: 0.46039505,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '37450924689339264',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B18/Rack_06',
      accureSoc: 0.48878708000000004,
      bmsSoc: 0.46714269999999997,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '57970417146406091',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B18/Rack_07',
      accureSoc: 0.52077217,
      bmsSoc: 0.49804099999999996,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '56908883118135827',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B18/Rack_08',
      accureSoc: 0.46479205999999995,
      bmsSoc: 0.54149567,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '66615624213342415',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B18/Rack_09',
      accureSoc: 0.47352825000000004,
      bmsSoc: 0.5780367,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '65081736682430764',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B18/Rack_10',
      accureSoc: 0.361603,
      bmsSoc: 0.57901955,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '1166578162839735',
      type: AssetType.CONTAINER,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B19',
      accureSoc: 0.42928914999999995,
      bmsSoc: 0.48629019799999995,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '41016897833360183',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B19/Rack_01',
      accureSoc: 0.4962534,
      bmsSoc: 0.44538787999999996,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '59330341324369333',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B19/Rack_02',
      accureSoc: 0.37423029999999996,
      bmsSoc: 0.4490436,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '40970096715439578',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B19/Rack_03',
      accureSoc: 0.39409557,
      bmsSoc: 0.50612328,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '41922314307811273',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B19/Rack_04',
      accureSoc: 0.35904766000000005,
      bmsSoc: 0.40534584,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '2026255838254836',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B19/Rack_05',
      accureSoc: 0.48030067000000004,
      bmsSoc: 0.5470524,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '51865357333988480',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B19/Rack_06',
      accureSoc: 0.44721522999999996,
      bmsSoc: 0.52501766,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '6277603696836004',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B19/Rack_07',
      accureSoc: 0.4920505,
      bmsSoc: 0.53331406,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '39160585113044302',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B19/Rack_08',
      accureSoc: 0.39673843,
      bmsSoc: 0.4433401,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '15525746307216519',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B19/Rack_09',
      accureSoc: 0.44841892,
      bmsSoc: 0.471365,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '13750238921869415',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B19/Rack_10',
      accureSoc: 0.40454082,
      bmsSoc: 0.53691216,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '65952089403350033',
      type: AssetType.CONTAINER,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B20',
      accureSoc: 0.452241876,
      bmsSoc: 0.5206233379999999,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '573834764319158',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B20/Rack_01',
      accureSoc: 0.48414764,
      bmsSoc: 0.5458293,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '15649704207484200',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B20/Rack_02',
      accureSoc: 0.49461563,
      bmsSoc: 0.50087585,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '66087345753916469',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B20/Rack_03',
      accureSoc: 0.47649002,
      bmsSoc: 0.5092896,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '34937527639391239',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B20/Rack_04',
      accureSoc: 0.39352580000000004,
      bmsSoc: 0.51206543,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '17562350934547220',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B20/Rack_05',
      accureSoc: 0.46905315000000003,
      bmsSoc: 0.56063324,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '20795102937643068',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B20/Rack_06',
      accureSoc: 0.45830596999999995,
      bmsSoc: 0.56887413,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '1625159942916716',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B20/Rack_07',
      accureSoc: 0.38363945,
      bmsSoc: 0.51438457,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '29545554138899483',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B20/Rack_08',
      accureSoc: 0.48210617,
      bmsSoc: 0.45564509999999997,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '35814042208166959',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B20/Rack_09',
      accureSoc: 0.38239243,
      bmsSoc: 0.54415504,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '51261903590874457',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B20/Rack_10',
      accureSoc: 0.4981425,
      bmsSoc: 0.49448112,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '56779848687839874',
      type: AssetType.CONTAINER,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B21',
      accureSoc: 0.422886869,
      bmsSoc: 0.5091242989999999,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '52187848566817573',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B21/Rack_01',
      accureSoc: 0.50752117,
      bmsSoc: 0.4990674,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '27170204668173644',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B21/Rack_02',
      accureSoc: 0.35201782000000004,
      bmsSoc: 0.56498764,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '6204771740522162',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B21/Rack_03',
      accureSoc: 0.45327,
      bmsSoc: 0.5249227,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '20906450787144733',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B21/Rack_04',
      accureSoc: 0.4001869,
      bmsSoc: 0.54652504,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '56701931486759686',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B21/Rack_05',
      accureSoc: 0.5052964,
      bmsSoc: 0.49497622999999996,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '39562889667935613',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B21/Rack_06',
      accureSoc: 0.40495109999999995,
      bmsSoc: 0.48831040000000003,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '53494161462184094',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B21/Rack_07',
      accureSoc: 0.42116974,
      bmsSoc: 0.5176467499999999,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '34966689709591649',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B21/Rack_08',
      accureSoc: 0.3703322,
      bmsSoc: 0.46824973999999997,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '31046135398117221',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B21/Rack_09',
      accureSoc: 0.41064056,
      bmsSoc: 0.43382645,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '39957277760540041',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B21/Rack_10',
      accureSoc: 0.40348280000000003,
      bmsSoc: 0.5527306399999999,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '6190551887328680',
      type: AssetType.CONTAINER,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B22',
      accureSoc: 0.40785619000000006,
      bmsSoc: 0.48557110500000006,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '9183437896062067',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B22/Rack_01',
      accureSoc: 0.5176017,
      bmsSoc: 0.45888249999999997,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '61750720480460367',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B22/Rack_02',
      accureSoc: 0.35993683,
      bmsSoc: 0.5417190000000001,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '5009413002640889',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B22/Rack_03',
      accureSoc: 0.3553919,
      bmsSoc: 0.46328968000000004,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '10439670912067822',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B22/Rack_04',
      accureSoc: 0.489294,
      bmsSoc: 0.41068325,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '37633342627217530',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B22/Rack_05',
      accureSoc: 0.4850726,
      bmsSoc: 0.5430778,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '15652258410448933',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B22/Rack_06',
      accureSoc: 0.36058723,
      bmsSoc: 0.49312862,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '29853818218223332',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B22/Rack_07',
      accureSoc: 0.35448597,
      bmsSoc: 0.44136615999999995,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '62893054815165414',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B22/Rack_08',
      accureSoc: 0.3855192,
      bmsSoc: 0.52528145,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '10163183405473968',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B22/Rack_09',
      accureSoc: 0.39211807,
      bmsSoc: 0.56197865,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '49400842981247887',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B22/Rack_10',
      accureSoc: 0.3785544,
      bmsSoc: 0.41630394000000004,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '28227970039726226',
      type: AssetType.CONTAINER,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B23',
      accureSoc: 0.42203116699999993,
      bmsSoc: 0.47315599599999997,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '62550064869972480',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B23/Rack_01',
      accureSoc: 0.35209539999999995,
      bmsSoc: 0.56943363,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '29724370716367113',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B23/Rack_02',
      accureSoc: 0.39552750000000003,
      bmsSoc: 0.42589794,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '1610670103853015',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B23/Rack_03',
      accureSoc: 0.51448566,
      bmsSoc: 0.44592285,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '69369577755331986',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B23/Rack_04',
      accureSoc: 0.39875785999999996,
      bmsSoc: 0.45346714,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '57639174054994672',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B23/Rack_05',
      accureSoc: 0.3852011,
      bmsSoc: 0.4239318,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '67365459092375554',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B23/Rack_06',
      accureSoc: 0.42990707,
      bmsSoc: 0.45265167,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '32689711467471291',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B23/Rack_07',
      accureSoc: 0.48000129999999996,
      bmsSoc: 0.4243072,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '6978883631691550',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B23/Rack_08',
      accureSoc: 0.49753050000000004,
      bmsSoc: 0.57461426,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '38305957045744950',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B23/Rack_09',
      accureSoc: 0.401522,
      bmsSoc: 0.5602998,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '68114984296474538',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B23/Rack_10',
      accureSoc: 0.36528328000000004,
      bmsSoc: 0.40103367,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '25686743170497907',
      type: AssetType.CONTAINER,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B24',
      accureSoc: 0.427335334,
      bmsSoc: 0.46859607799999997,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '17201046990530016',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B24/Rack_01',
      accureSoc: 0.45844482,
      bmsSoc: 0.50250153,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '61434457278327309',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B24/Rack_02',
      accureSoc: 0.45142735,
      bmsSoc: 0.5055511,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '27400757141998347',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B24/Rack_03',
      accureSoc: 0.38739502000000003,
      bmsSoc: 0.44470097000000003,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '20110464637511486',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B24/Rack_04',
      accureSoc: 0.4064956,
      bmsSoc: 0.39733130000000005,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '45041541419960412',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B24/Rack_05',
      accureSoc: 0.39815517,
      bmsSoc: 0.4178004,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '66839987110890160',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B24/Rack_06',
      accureSoc: 0.5245627,
      bmsSoc: 0.52283886,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '34546484587110454',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B24/Rack_07',
      accureSoc: 0.36831245,
      bmsSoc: 0.44090702,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '52855507319075531',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B24/Rack_08',
      accureSoc: 0.45584389999999997,
      bmsSoc: 0.43783527,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '31085199199260777',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B24/Rack_09',
      accureSoc: 0.36616566,
      bmsSoc: 0.45239796,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '50712416082944508',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B24/Rack_10',
      accureSoc: 0.45655067000000005,
      bmsSoc: 0.56409637,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '57540051426467851',
      type: AssetType.CONTAINER,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B25',
      accureSoc: 0.44836538299999995,
      bmsSoc: 0.47487377099999994,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '24504887961452069',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B25/Rack_01',
      accureSoc: 0.43093623999999997,
      bmsSoc: 0.4853586,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '28117427348915420',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B25/Rack_02',
      accureSoc: 0.4085234,
      bmsSoc: 0.5619405,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '6958246851868558',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B25/Rack_03',
      accureSoc: 0.5257288,
      bmsSoc: 0.413595,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '2954543959903114',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B25/Rack_04',
      accureSoc: 0.44756461999999997,
      bmsSoc: 0.45672260000000003,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '6540304199980755',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B25/Rack_05',
      accureSoc: 0.51462948,
      bmsSoc: 0.39376663,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '47665735283617424',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B25/Rack_06',
      accureSoc: 0.50337334,
      bmsSoc: 0.44976025,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '69095184924677916',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B25/Rack_07',
      accureSoc: 0.42813029999999996,
      bmsSoc: 0.42820084,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '24121244713338821',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B25/Rack_08',
      accureSoc: 0.48758205,
      bmsSoc: 0.4995252,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '6429553694724504',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B25/Rack_09',
      accureSoc: 0.35968559999999994,
      bmsSoc: 0.5391228499999999,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '2435862662525847',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B25/Rack_10',
      accureSoc: 0.3775,
      bmsSoc: 0.52074524,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '25335588316095982',
      type: AssetType.CONTAINER,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B26',
      accureSoc: 0.422101235,
      bmsSoc: 0.49995007,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '14581783459110500',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B26/Rack_01',
      accureSoc: 0.35718266,
      bmsSoc: 0.55396156,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '59395084066388735',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B26/Rack_02',
      accureSoc: 0.44310326000000005,
      bmsSoc: 0.45573757,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '17852576880260495',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B26/Rack_03',
      accureSoc: 0.47632359999999996,
      bmsSoc: 0.5305381,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '32790652432554140',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B26/Rack_04',
      accureSoc: 0.41521175,
      bmsSoc: 0.507541,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '61659681451544347',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B26/Rack_05',
      accureSoc: 0.49929264,
      bmsSoc: 0.48463164999999997,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '40969798542131576',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B26/Rack_06',
      accureSoc: 0.41319813000000005,
      bmsSoc: 0.51101257,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '22596396457745528',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B26/Rack_07',
      accureSoc: 0.37757126,
      bmsSoc: 0.57094322,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '56079652480746013',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B26/Rack_08',
      accureSoc: 0.40629420000000005,
      bmsSoc: 0.5351903,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '10010385498247626',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B26/Rack_09',
      accureSoc: 0.37254795,
      bmsSoc: 0.42380177,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '30388637531089197',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B26/Rack_10',
      accureSoc: 0.4602869,
      bmsSoc: 0.42614296,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '67465371223031458',
      type: AssetType.CONTAINER,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B27',
      accureSoc: 0.4237167660000001,
      bmsSoc: 0.5152561010000001,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '67656174610726294',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B27/Rack_01',
      accureSoc: 0.3806364,
      bmsSoc: 0.54239708,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '4061514289691207',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B27/Rack_02',
      accureSoc: 0.35814480000000004,
      bmsSoc: 0.39835279999999995,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '36354892003688144',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B27/Rack_03',
      accureSoc: 0.3951493,
      bmsSoc: 0.47719543000000003,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '32471773617279006',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B27/Rack_04',
      accureSoc: 0.39193924,
      bmsSoc: 0.42726664999999997,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '28545074712574921',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B27/Rack_05',
      accureSoc: 0.52166317,
      bmsSoc: 0.5783993000000001,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '53237918646524405',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B27/Rack_06',
      accureSoc: 0.47482693,
      bmsSoc: 0.55483826,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '48661999858345633',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B27/Rack_07',
      accureSoc: 0.51021896,
      bmsSoc: 0.5834738,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '35017299569429283',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B27/Rack_08',
      accureSoc: 0.36959152,
      bmsSoc: 0.57361046,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '70410253746328374',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B27/Rack_09',
      accureSoc: 0.44945934,
      bmsSoc: 0.5037311,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '46976829218980256',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B27/Rack_10',
      accureSoc: 0.38553800000000005,
      bmsSoc: 0.5132961300000001,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '57935239604972820',
      type: AssetType.CONTAINER,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B28',
      accureSoc: 0.44439408799999996,
      bmsSoc: 0.48781864900000005,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '15990764837004244',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B28/Rack_01',
      accureSoc: 0.49096172000000005,
      bmsSoc: 0.5606407,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '43457394153082489',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B28/Rack_02',
      accureSoc: 0.46533928,
      bmsSoc: 0.5076645,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '13471351640558659',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B28/Rack_03',
      accureSoc: 0.39970276,
      bmsSoc: 0.46130203000000003,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '43257018117311641',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B28/Rack_04',
      accureSoc: 0.43062779999999995,
      bmsSoc: 0.48361458,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '44441210032859093',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B28/Rack_05',
      accureSoc: 0.43777126000000005,
      bmsSoc: 0.54679436,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '56809198314856746',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B28/Rack_06',
      accureSoc: 0.51696564,
      bmsSoc: 0.41248943,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '52892527099087293',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B28/Rack_07',
      accureSoc: 0.44668236,
      bmsSoc: 0.41542941999999994,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '1517276912271249',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B28/Rack_08',
      accureSoc: 0.3744446,
      bmsSoc: 0.57963955,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '642901347155358',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B28/Rack_09',
      accureSoc: 0.44025696000000003,
      bmsSoc: 0.39664924999999995,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '16728424670061118',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B28/Rack_10',
      accureSoc: 0.44118850000000004,
      bmsSoc: 0.5139626700000001,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '26038036222907881',
      type: AssetType.CONTAINER,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B29',
      accureSoc: 0.434175793,
      bmsSoc: 0.484993242,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '46434595840970237',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B29/Rack_01',
      accureSoc: 0.36540947,
      bmsSoc: 0.56920444,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '38611058194173256',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B29/Rack_02',
      accureSoc: 0.42045340000000003,
      bmsSoc: 0.4641356,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '70046936809406829',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B29/Rack_03',
      accureSoc: 0.38522182,
      bmsSoc: 0.5721453000000001,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '18076209839280849',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B29/Rack_04',
      accureSoc: 0.42995693,
      bmsSoc: 0.43736908,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '54733539380796709',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B29/Rack_05',
      accureSoc: 0.4921161,
      bmsSoc: 0.45713375,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '37167083848744828',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B29/Rack_06',
      accureSoc: 0.48503480000000004,
      bmsSoc: 0.42211895,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '35197177310155977',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B29/Rack_07',
      accureSoc: 0.4803904,
      bmsSoc: 0.46568398,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '69588550128907886',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B29/Rack_08',
      accureSoc: 0.43942608,
      bmsSoc: 0.42424439999999997,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '54987447907194742',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B29/Rack_09',
      accureSoc: 0.37857773,
      bmsSoc: 0.53519695,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '22959367894914781',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B29/Rack_10',
      accureSoc: 0.4651712,
      bmsSoc: 0.50269997,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '37567530921115554',
      type: AssetType.CONTAINER,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B30',
      accureSoc: 0.4465221439999999,
      bmsSoc: 0.501469374,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '54426466015475921',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B30/Rack_01',
      accureSoc: 0.48969085999999995,
      bmsSoc: 0.5818971,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '769405584894263',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B30/Rack_02',
      accureSoc: 0.40611539999999996,
      bmsSoc: 0.51818718,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '44604054646835931',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B30/Rack_03',
      accureSoc: 0.5201015999999999,
      bmsSoc: 0.5389545,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '12242169608091269',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B30/Rack_04',
      accureSoc: 0.46516179999999996,
      bmsSoc: 0.48758804,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '60137551809065668',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B30/Rack_05',
      accureSoc: 0.42095170000000004,
      bmsSoc: 0.56713654,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '49907290519630689',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B30/Rack_06',
      accureSoc: 0.5107924,
      bmsSoc: 0.52715446,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '39521135278296569',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B30/Rack_07',
      accureSoc: 0.42739307,
      bmsSoc: 0.55044384,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '45762990185226657',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B30/Rack_08',
      accureSoc: 0.37676044,
      bmsSoc: 0.42853714,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '40376310974477272',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B30/Rack_09',
      accureSoc: 0.46844975,
      bmsSoc: 0.3936302,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '11931954233655033',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B30/Rack_10',
      accureSoc: 0.37980442,
      bmsSoc: 0.42116474,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '29520743539604972',
      type: AssetType.CONTAINER,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B31',
      accureSoc: 0.4313103590000001,
      bmsSoc: 0.521278698,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '3516879690624759',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B31/Rack_01',
      accureSoc: 0.48430286,
      bmsSoc: 0.48591949999999995,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '36314423494654061',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B31/Rack_02',
      accureSoc: 0.52010227,
      bmsSoc: 0.54649982,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '23741111991284011',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B31/Rack_03',
      accureSoc: 0.39501198000000004,
      bmsSoc: 0.5748442500000001,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '36562173920921604',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B31/Rack_04',
      accureSoc: 0.3872423,
      bmsSoc: 0.5205668,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '20595154266960448',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B31/Rack_05',
      accureSoc: 0.5071287999999999,
      bmsSoc: 0.57210102,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '42577330539636526',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B31/Rack_06',
      accureSoc: 0.40219444000000004,
      bmsSoc: 0.41986137,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '13713968915224737',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B31/Rack_07',
      accureSoc: 0.41138554,
      bmsSoc: 0.5117423200000001,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '27927971759830067',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B31/Rack_08',
      accureSoc: 0.45991535,
      bmsSoc: 0.5379596999999999,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '52491862310218294',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B31/Rack_09',
      accureSoc: 0.37604390000000004,
      bmsSoc: 0.5192381699999999,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '35059889886841900',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Country_Corner/B31/Rack_10',
      accureSoc: 0.36977615,
      bmsSoc: 0.52405403,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
  ],
  '23456': [
    {
      id: '2345601',
      type: AssetType.PCS,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/PCS_01',
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {},
    },
    {
      id: '2345602',
      type: AssetType.PCS,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/PCS_02',
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {},
    },
    {
      id: '2345603',
      type: AssetType.PCS,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/PCS_03',
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {},
    },
    {
      id: '2345604',
      type: AssetType.PCS,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/PCS_04',
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {},
    },
    {
      id: '2345605',
      type: AssetType.PCS,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/PCS_05',
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {},
    },
    {
      id: '2345606',
      type: AssetType.PCS,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/PCS_06',
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {},
    },
    {
      id: '2345607',
      type: AssetType.PCS,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/PCS_07',
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {},
    },
    {
      id: '2345608',
      type: AssetType.PCS,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/PCS_08',
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {},
    },
    {
      id: '2345609',
      type: AssetType.PCS,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/PCS_09',
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {},
    },
    {
      id: '2345610',
      type: AssetType.PCS,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/PCS_10',
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {},
    },
    {
      id: '2345611',
      type: AssetType.PCS,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/PCS_11',
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {},
    },
    {
      id: '2345612',
      type: AssetType.PCS,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/PCS_12',
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {},
    },
    {
      id: '2345613',
      type: AssetType.PCS,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/PCS_13',
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {},
    },
    {
      id: '2345614',
      type: AssetType.PCS,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/PCS_14',
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {},
    },
    {
      id: '2345615',
      type: AssetType.PCS,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/PCS_15',
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {},
    },
    {
      id: '2345616',
      type: AssetType.PCS,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/PCS_16',
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {},
    },
    {
      id: '2345617',
      type: AssetType.PCS,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/PCS_17',
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {},
    },
    {
      id: '2345618',
      type: AssetType.PCS,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/PCS_18',
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {},
    },
    {
      id: '2345619',
      type: AssetType.PCS,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/PCS_19',
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {},
    },
    {
      id: '30718404103119905',
      type: AssetType.CONTAINER,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B01',
      accureSoc: 0.746273813,
      bmsSoc: 0.715129583,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '35079599492552134',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B01/Rack_01',
      accureSoc: 0.60583298,
      bmsSoc: 0.60599983,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '60657763325243915',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B01/Rack_02',
      accureSoc: 0.7458395400000001,
      bmsSoc: 0.6302247,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '43258961377223634',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B01/Rack_03',
      accureSoc: 0.74106476,
      bmsSoc: 0.7981568,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '23354183706937396',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B01/Rack_04',
      accureSoc: 0.7693420000000001,
      bmsSoc: 0.78177574,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '1848370142396384',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B01/Rack_05',
      accureSoc: 0.8650660000000001,
      bmsSoc: 0.7186919,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '18480505217750404',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B01/Rack_06',
      accureSoc: 0.6406406,
      bmsSoc: 0.8487724,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '43744028884453053',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B01/Rack_07',
      accureSoc: 0.73878525,
      bmsSoc: 0.84675,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '17553539178570896',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B01/Rack_08',
      accureSoc: 0.7622136999999999,
      bmsSoc: 0.6275238000000001,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '22692834682381922',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B01/Rack_09',
      accureSoc: 0.7383322,
      bmsSoc: 0.6646572999999999,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '335446477564378',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B01/Rack_10',
      accureSoc: 0.8556211,
      bmsSoc: 0.62874336,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '20132512127652605',
      type: AssetType.CONTAINER,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B02',
      accureSoc: 0.6942604320000001,
      bmsSoc: 0.7197490019999999,
      alertStatus: AlertStatus.WARNING,
      nbOpenTasks: 2,
      metadata: {
        capacity: 1000000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '62459970151819100',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B02/Rack_01',
      accureSoc: 0.61597263,
      bmsSoc: 0.8335387,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '28726395311334323',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B02/Rack_02',
      accureSoc: 0.6917237,
      bmsSoc: 0.651838,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '71351724769407902',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B02/Rack_03',
      accureSoc: 0.7264735,
      bmsSoc: 0.8517672000000001,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '41945816501081001',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B02/Rack_04',
      accureSoc: 0.65184586,
      bmsSoc: 0.66189926,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '53265910630541263',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B02/Rack_05',
      accureSoc: 0.7356344,
      bmsSoc: 0.6983618,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '21037161735465121',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B02/Rack_06',
      accureSoc: 0.6456779,
      bmsSoc: 0.71992256,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '23563816371734243',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B02/Rack_07',
      accureSoc: 0.61334343,
      bmsSoc: 0.7131522,
      alertStatus: AlertStatus.CRITICAL,
      nbOpenTasks: 1,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '68483868567566294',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B02/Rack_08',
      accureSoc: 0.7890771999999999,
      bmsSoc: 0.6320655399999999,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '38135837023795626',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B02/Rack_09',
      accureSoc: 0.8046772,
      bmsSoc: 0.76783966,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '38904549177912417',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B02/Rack_10',
      accureSoc: 0.6681785000000001,
      bmsSoc: 0.6671051,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '26375145252243301',
      type: AssetType.CONTAINER,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B03',
      accureSoc: 0.696914857,
      bmsSoc: 0.736366949,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '30714843013249091',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B03/Rack_01',
      accureSoc: 0.59201645,
      bmsSoc: 0.7122617,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '25788169519644835',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B03/Rack_02',
      accureSoc: 0.6583751999999999,
      bmsSoc: 0.78621735,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '51197728079149998',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B03/Rack_03',
      accureSoc: 0.6966661000000001,
      bmsSoc: 0.8173475,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '67052612123657520',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B03/Rack_04',
      accureSoc: 0.6471867,
      bmsSoc: 0.7179997,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '50017465982186910',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B03/Rack_05',
      accureSoc: 0.82006836,
      bmsSoc: 0.7026507,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '65050616771379947',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B03/Rack_06',
      accureSoc: 0.8753791,
      bmsSoc: 0.77389854,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '20647062452501250',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B03/Rack_07',
      accureSoc: 0.7163708,
      bmsSoc: 0.6730047,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '55047696560349703',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B03/Rack_08',
      accureSoc: 0.59028816,
      bmsSoc: 0.66113365,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '57672893553099070',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B03/Rack_09',
      accureSoc: 0.7326488999999999,
      bmsSoc: 0.8578275999999999,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '46294422344634429',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B03/Rack_10',
      accureSoc: 0.6401488000000001,
      bmsSoc: 0.6613280500000001,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '40744635163444372',
      type: AssetType.CONTAINER,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B04',
      accureSoc: 0.7313438929999999,
      bmsSoc: 0.753924874,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '21031235340488397',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B04/Rack_01',
      accureSoc: 0.7750785,
      bmsSoc: 0.8727432,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '52104864305480172',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B04/Rack_02',
      accureSoc: 0.6216536,
      bmsSoc: 0.8339629,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '14078335744370971',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B04/Rack_03',
      accureSoc: 0.7508176400000001,
      bmsSoc: 0.7083099,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '20280190013234747',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B04/Rack_04',
      accureSoc: 0.7998823500000001,
      bmsSoc: 0.69424164,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '59713406893582856',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B04/Rack_05',
      accureSoc: 0.63858578,
      bmsSoc: 0.8849022999999999,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '11850571627739532',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B04/Rack_06',
      accureSoc: 0.6706881,
      bmsSoc: 0.6155467,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '15619113561839834',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B04/Rack_07',
      accureSoc: 0.850601,
      bmsSoc: 0.7435805999999999,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '56019295785122494',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B04/Rack_08',
      accureSoc: 0.70344246,
      bmsSoc: 0.8072052,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '45233964787214109',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B04/Rack_09',
      accureSoc: 0.8084808,
      bmsSoc: 0.7458248000000001,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '25285983738490723',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B04/Rack_10',
      accureSoc: 0.6942086999999999,
      bmsSoc: 0.6329315,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '47538560548968574',
      type: AssetType.CONTAINER,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B05',
      accureSoc: 0.7189345850000001,
      bmsSoc: 0.7110273990000002,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '63358222093392503',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B05/Rack_01',
      accureSoc: 0.69246895,
      bmsSoc: 0.7103416,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '20917327876710154',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B05/Rack_02',
      accureSoc: 0.7253653,
      bmsSoc: 0.78375305,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '59723555043838889',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B05/Rack_03',
      accureSoc: 0.8614427,
      bmsSoc: 0.7854792,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '71731959769522196',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B05/Rack_04',
      accureSoc: 0.5983496,
      bmsSoc: 0.7346803,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '35527547318755671',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B05/Rack_05',
      accureSoc: 0.7647007000000001,
      bmsSoc: 0.7163111000000001,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '2160660447756477',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B05/Rack_06',
      accureSoc: 0.59571575,
      bmsSoc: 0.5987498,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '60955602330446930',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B05/Rack_07',
      accureSoc: 0.7289042000000001,
      bmsSoc: 0.5984023700000001,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '12129653793088123',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B05/Rack_08',
      accureSoc: 0.8048009500000001,
      bmsSoc: 0.62544807,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '69127980137566436',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B05/Rack_09',
      accureSoc: 0.6678938999999999,
      bmsSoc: 0.6631483,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '7177186809680055',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B05/Rack_10',
      accureSoc: 0.7497038,
      bmsSoc: 0.8939602,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '31073992737191951',
      type: AssetType.CONTAINER,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B06',
      accureSoc: 0.7090988250000001,
      bmsSoc: 0.7639073639999999,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 1,
      metadata: {
        capacity: 1000000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '9175395037137693',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B06/Rack_01',
      accureSoc: 0.64991646,
      bmsSoc: 0.7850538,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '43840062496099364',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B06/Rack_02',
      accureSoc: 0.7765242000000001,
      bmsSoc: 0.6210732,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '42336978694889711',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B06/Rack_03',
      accureSoc: 0.7227267999999999,
      bmsSoc: 0.7888222,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '31450277216898505',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B06/Rack_04',
      accureSoc: 0.79457306,
      bmsSoc: 0.7370713999999999,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '27192598374848000',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B06/Rack_05',
      accureSoc: 0.68699066,
      bmsSoc: 0.8614686,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '28102434435720603',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B06/Rack_06',
      accureSoc: 0.6812216,
      bmsSoc: 0.8782752,
      alertStatus: AlertStatus.WARNING,
      nbOpenTasks: 1,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '67399618892451013',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B06/Rack_07',
      accureSoc: 0.7552146999999999,
      bmsSoc: 0.8529853,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '33778278923414646',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B06/Rack_08',
      accureSoc: 0.62430527,
      bmsSoc: 0.6445221999999999,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '58760079855280155',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B06/Rack_09',
      accureSoc: 0.6994889999999999,
      bmsSoc: 0.6609668999999999,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '34135204102489899',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B06/Rack_10',
      accureSoc: 0.7000265,
      bmsSoc: 0.8088348399999999,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '5646263683372337',
      type: AssetType.CONTAINER,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B07',
      accureSoc: 0.7382538219999999,
      bmsSoc: 0.7633068069999999,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '32437083433113149',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B07/Rack_01',
      accureSoc: 0.63658157,
      bmsSoc: 0.59928627,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '4416030866688505',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B07/Rack_02',
      accureSoc: 0.77999176,
      bmsSoc: 0.8872978,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '39763829747641606',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B07/Rack_03',
      accureSoc: 0.7782719,
      bmsSoc: 0.7051987,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '49909109682713087',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B07/Rack_04',
      accureSoc: 0.7173518,
      bmsSoc: 0.8309921,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '47543278782853757',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B07/Rack_05',
      accureSoc: 0.59910713,
      bmsSoc: 0.7936751,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '8670882970050692',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B07/Rack_06',
      accureSoc: 0.8333959,
      bmsSoc: 0.7513952,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '27283040611375227',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B07/Rack_07',
      accureSoc: 0.6271958999999999,
      bmsSoc: 0.7843981999999999,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '38035985200834664',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B07/Rack_08',
      accureSoc: 0.84428856,
      bmsSoc: 0.7278682999999999,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '12174772515007284',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B07/Rack_09',
      accureSoc: 0.7270157,
      bmsSoc: 0.8339252,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '65698748464844387',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B07/Rack_10',
      accureSoc: 0.839338,
      bmsSoc: 0.7190312,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '25095599520628136',
      type: AssetType.CONTAINER,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B08',
      accureSoc: 0.7741690709999999,
      bmsSoc: 0.73393743,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '57142606006411498',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B08/Rack_01',
      accureSoc: 0.85907555,
      bmsSoc: 0.8140921,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '10958493489220936',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B08/Rack_02',
      accureSoc: 0.6707933,
      bmsSoc: 0.6410686,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '14754308508559561',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B08/Rack_03',
      accureSoc: 0.8758902999999999,
      bmsSoc: 0.643308,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '37940774952553839',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B08/Rack_04',
      accureSoc: 0.79188896,
      bmsSoc: 0.7353064,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '43509776735966515',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B08/Rack_05',
      accureSoc: 0.6992519,
      bmsSoc: 0.8323112500000001,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '58135030007642909',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B08/Rack_06',
      accureSoc: 0.7681207000000001,
      bmsSoc: 0.6855536999999999,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '31414145010902092',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B08/Rack_07',
      accureSoc: 0.7541121,
      bmsSoc: 0.6723305,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '17818051774895706',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B08/Rack_08',
      accureSoc: 0.6212901,
      bmsSoc: 0.66085686,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '21013071767130086',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B08/Rack_09',
      accureSoc: 0.8423453000000001,
      bmsSoc: 0.80984505,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '10801577876736588',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B08/Rack_10',
      accureSoc: 0.8589225,
      bmsSoc: 0.84470184,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '1869295039075929',
      type: AssetType.CONTAINER,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B09',
      accureSoc: 0.7068026119999999,
      bmsSoc: 0.731414687,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '11375593899123091',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B09/Rack_01',
      accureSoc: 0.6632764400000001,
      bmsSoc: 0.8042475,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '47381622689104084',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B09/Rack_02',
      accureSoc: 0.64878654,
      bmsSoc: 0.7385653999999999,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '55709521646384897',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B09/Rack_03',
      accureSoc: 0.59237232,
      bmsSoc: 0.5978822699999999,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '7302099969241602',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B09/Rack_04',
      accureSoc: 0.7522643999999999,
      bmsSoc: 0.82279526,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '70994875044936437',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B09/Rack_05',
      accureSoc: 0.8733863,
      bmsSoc: 0.62672596,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '16576714102091540',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B09/Rack_06',
      accureSoc: 0.7445301999999999,
      bmsSoc: 0.8220061,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '22491353107430450',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B09/Rack_07',
      accureSoc: 0.67469955,
      bmsSoc: 0.7129173,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '71333124671386150',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B09/Rack_08',
      accureSoc: 0.7095049,
      bmsSoc: 0.6045969800000001,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '48508834435066572',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B09/Rack_09',
      accureSoc: 0.63061527,
      bmsSoc: 0.7661231,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '69392820513795688',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B09/Rack_10',
      accureSoc: 0.7785902,
      bmsSoc: 0.818287,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '7188901685439760',
      type: AssetType.CONTAINER,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B10',
      accureSoc: 0.7680837900000002,
      bmsSoc: 0.7586557150000002,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '32660616734568296',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B10/Rack_01',
      accureSoc: 0.8316476,
      bmsSoc: 0.8507887,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '60902590282422794',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B10/Rack_02',
      accureSoc: 0.6593358600000001,
      bmsSoc: 0.7861835,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '57024869034213961',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B10/Rack_03',
      accureSoc: 0.8203007499999999,
      bmsSoc: 0.6674273,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '782363481701581',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B10/Rack_04',
      accureSoc: 0.6002514999999999,
      bmsSoc: 0.6423669,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '17633189750374630',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B10/Rack_05',
      accureSoc: 0.7749467,
      bmsSoc: 0.7679819000000001,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '69530651245263361',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B10/Rack_06',
      accureSoc: 0.79188255,
      bmsSoc: 0.7592686500000001,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '48496545838971648',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B10/Rack_07',
      accureSoc: 0.8638705,
      bmsSoc: 0.6079703,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '66841037154927878',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B10/Rack_08',
      accureSoc: 0.87479,
      bmsSoc: 0.7374142,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '70285715384723094',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B10/Rack_09',
      accureSoc: 0.81656334,
      bmsSoc: 0.8804813,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '63758290874505012',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B10/Rack_10',
      accureSoc: 0.6472490999999999,
      bmsSoc: 0.8866744,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '37587440701671119',
      type: AssetType.CONTAINER,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B11',
      accureSoc: 0.730383636,
      bmsSoc: 0.6932165990000001,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '28124858374632774',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B11/Rack_01',
      accureSoc: 0.6434361,
      bmsSoc: 0.6721969,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '47245680462390628',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B11/Rack_02',
      accureSoc: 0.60025906,
      bmsSoc: 0.62451412,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '45277147157392250',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B11/Rack_03',
      accureSoc: 0.8016468,
      bmsSoc: 0.60435795,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '60679825139275974',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B11/Rack_04',
      accureSoc: 0.6333276,
      bmsSoc: 0.62874874,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '56721372420565342',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B11/Rack_05',
      accureSoc: 0.6751001999999999,
      bmsSoc: 0.6960393500000001,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '22447779129517378',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B11/Rack_06',
      accureSoc: 0.8340738000000001,
      bmsSoc: 0.67486824,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '5053232663135502',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B11/Rack_07',
      accureSoc: 0.8572996,
      bmsSoc: 0.7340059,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '69456142569331638',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B11/Rack_08',
      accureSoc: 0.7539745999999999,
      bmsSoc: 0.69994125,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '31562446424791925',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B11/Rack_09',
      accureSoc: 0.7544301,
      bmsSoc: 0.7510319,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '67775263096565749',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B11/Rack_10',
      accureSoc: 0.7502885,
      bmsSoc: 0.84646164,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '31646670405234952',
      type: AssetType.CONTAINER,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B12',
      accureSoc: 0.7621393139999999,
      bmsSoc: 0.743566732,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '57654656088194761',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B12/Rack_01',
      accureSoc: 0.6242303,
      bmsSoc: 0.6267107,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '69268198814781637',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B12/Rack_02',
      accureSoc: 0.7908211,
      bmsSoc: 0.7337917,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '12958175526162777',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B12/Rack_03',
      accureSoc: 0.59709846,
      bmsSoc: 0.69519066,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '55125871943037286',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B12/Rack_04',
      accureSoc: 0.8201663,
      bmsSoc: 0.852478,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '56101294836430947',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B12/Rack_05',
      accureSoc: 0.8567467000000001,
      bmsSoc: 0.7239445499999999,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '19837581716408589',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B12/Rack_06',
      accureSoc: 0.83234184,
      bmsSoc: 0.8080826600000001,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '56685402963130941',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B12/Rack_07',
      accureSoc: 0.6640438000000001,
      bmsSoc: 0.6952406999999999,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '71429198033057053',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B12/Rack_08',
      accureSoc: 0.72643654,
      bmsSoc: 0.6436468999999999,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '19246583507602064',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B12/Rack_09',
      accureSoc: 0.8522894999999999,
      bmsSoc: 0.7843407,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '12846182028686806',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B12/Rack_10',
      accureSoc: 0.8572186,
      bmsSoc: 0.87224075,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '63112088927389728',
      type: AssetType.CONTAINER,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B13',
      accureSoc: 0.698075125,
      bmsSoc: 0.7158019760000001,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '51222084024797903',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B13/Rack_01',
      accureSoc: 0.664739,
      bmsSoc: 0.6018358,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '39170229262137232',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B13/Rack_02',
      accureSoc: 0.7883688,
      bmsSoc: 0.6685317999999999,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '3959540137519683',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B13/Rack_03',
      accureSoc: 0.63508415,
      bmsSoc: 0.6878612,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '71907166678705129',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B13/Rack_04',
      accureSoc: 0.64085464,
      bmsSoc: 0.62847446,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '2555834305027008',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B13/Rack_05',
      accureSoc: 0.6499731,
      bmsSoc: 0.8768877,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '60725584928870431',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B13/Rack_06',
      accureSoc: 0.6790501999999999,
      bmsSoc: 0.8565808,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '66285326418257502',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B13/Rack_07',
      accureSoc: 0.8581238600000001,
      bmsSoc: 0.6016372,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '4958850007594793',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B13/Rack_08',
      accureSoc: 0.65345406,
      bmsSoc: 0.6160129,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '23720656675694581',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B13/Rack_09',
      accureSoc: 0.59207764,
      bmsSoc: 0.7653835999999999,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '1076878984484970',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B13/Rack_10',
      accureSoc: 0.8190258,
      bmsSoc: 0.8548143,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '71598940471247509',
      type: AssetType.CONTAINER,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B14',
      accureSoc: 0.716138984,
      bmsSoc: 0.8002111460000001,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '23606146050822795',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B14/Rack_01',
      accureSoc: 0.62975704,
      bmsSoc: 0.8514213599999999,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '44938263530984610',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B14/Rack_02',
      accureSoc: 0.6779569999999999,
      bmsSoc: 0.7359193399999999,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '61178743930976533',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B14/Rack_03',
      accureSoc: 0.7478995999999999,
      bmsSoc: 0.8608704,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '13560460717256566',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B14/Rack_04',
      accureSoc: 0.63441616,
      bmsSoc: 0.8905945599999999,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '54307276412371338',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B14/Rack_05',
      accureSoc: 0.7077766400000001,
      bmsSoc: 0.7967028,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '50815937617313589',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B14/Rack_06',
      accureSoc: 0.6778543,
      bmsSoc: 0.7140662,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '3924482271833987',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B14/Rack_07',
      accureSoc: 0.6363728,
      bmsSoc: 0.8617686,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '35662694575693330',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B14/Rack_08',
      accureSoc: 0.7288532,
      bmsSoc: 0.7802415,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '8046538368927418',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B14/Rack_09',
      accureSoc: 0.8809473,
      bmsSoc: 0.8521361000000001,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '33278398670163058',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B14/Rack_10',
      accureSoc: 0.8395558,
      bmsSoc: 0.6583906,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '30419150012822155',
      type: AssetType.CONTAINER,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B15',
      accureSoc: 0.684615615,
      bmsSoc: 0.7527655169999999,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '13744263605342591',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B15/Rack_01',
      accureSoc: 0.8355327,
      bmsSoc: 0.8793515,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '24013042471477128',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B15/Rack_02',
      accureSoc: 0.6728789000000001,
      bmsSoc: 0.73014496,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '33017895459320372',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B15/Rack_03',
      accureSoc: 0.6561342,
      bmsSoc: 0.6082404,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '13955951463951367',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B15/Rack_04',
      accureSoc: 0.6539201,
      bmsSoc: 0.75378716,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '68227863705749090',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B15/Rack_05',
      accureSoc: 0.7121487999999999,
      bmsSoc: 0.6756302,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '19560451941931963',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B15/Rack_06',
      accureSoc: 0.5920712,
      bmsSoc: 0.6430612000000001,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '48947680750511434',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B15/Rack_07',
      accureSoc: 0.8226815000000001,
      bmsSoc: 0.7081194000000001,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '24607581275318618',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B15/Rack_08',
      accureSoc: 0.6702352,
      bmsSoc: 0.8914547,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '43127281990156594',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B15/Rack_09',
      accureSoc: 0.6141749200000001,
      bmsSoc: 0.83755875,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '49125336693456848',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B15/Rack_10',
      accureSoc: 0.61637863,
      bmsSoc: 0.8003069,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '44704272828581916',
      type: AssetType.CONTAINER,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B16',
      accureSoc: 0.7313911569999999,
      bmsSoc: 0.747979759,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '42258704915988588',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B16/Rack_01',
      accureSoc: 0.65722565,
      bmsSoc: 0.60236595,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '45160022361051610',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B16/Rack_02',
      accureSoc: 0.8817695999999999,
      bmsSoc: 0.8002642,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '206388036881247',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B16/Rack_03',
      accureSoc: 0.77178635,
      bmsSoc: 0.7763212,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '22164310707695651',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B16/Rack_04',
      accureSoc: 0.6216392,
      bmsSoc: 0.7399841,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '24697274947705184',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B16/Rack_05',
      accureSoc: 0.84620346,
      bmsSoc: 0.87990654,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '60233673394640248',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B16/Rack_06',
      accureSoc: 0.7986190000000001,
      bmsSoc: 0.755303,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '17580527052179391',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B16/Rack_07',
      accureSoc: 0.7998099499999999,
      bmsSoc: 0.6980834,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '33521742613704712',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B16/Rack_08',
      accureSoc: 0.6445736,
      bmsSoc: 0.6775771,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '18833102232759435',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B16/Rack_09',
      accureSoc: 0.6888687,
      bmsSoc: 0.8020088,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '17913064679708754',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B16/Rack_10',
      accureSoc: 0.60341606,
      bmsSoc: 0.7479833,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '58234417308923101',
      type: AssetType.CONTAINER,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B17',
      accureSoc: 0.719212476,
      bmsSoc: 0.8217947200000001,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '53828508804375926',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B17/Rack_01',
      accureSoc: 0.60521805,
      bmsSoc: 0.8885758,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '48670519692338213',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B17/Rack_02',
      accureSoc: 0.7888219,
      bmsSoc: 0.7991688499999999,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '13208265763049318',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B17/Rack_03',
      accureSoc: 0.76293106,
      bmsSoc: 0.858347,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '19552475340290172',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B17/Rack_04',
      accureSoc: 0.7060622999999999,
      bmsSoc: 0.8825555,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '4898952035945218',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B17/Rack_05',
      accureSoc: 0.84594986,
      bmsSoc: 0.8466317999999999,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '15850813590925959',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B17/Rack_06',
      accureSoc: 0.7212311,
      bmsSoc: 0.8449595999999999,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '52521187362286770',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B17/Rack_07',
      accureSoc: 0.65580605,
      bmsSoc: 0.8120578999999999,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '54430293987184687',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B17/Rack_08',
      accureSoc: 0.6108408399999999,
      bmsSoc: 0.65087585,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '23213235943792871',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B17/Rack_09',
      accureSoc: 0.6710715500000001,
      bmsSoc: 0.7893568999999999,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '26385332725240731',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B17/Rack_10',
      accureSoc: 0.8241920500000001,
      bmsSoc: 0.845418,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '71738629612187595',
      type: AssetType.CONTAINER,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B18',
      accureSoc: 0.7334349460000001,
      bmsSoc: 0.7190127470000001,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '43089236366906994',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B18/Rack_01',
      accureSoc: 0.6613000499999999,
      bmsSoc: 0.7413406,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '63768954693150466',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B18/Rack_02',
      accureSoc: 0.76771835,
      bmsSoc: 0.7351411400000001,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '35095534864345407',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B18/Rack_03',
      accureSoc: 0.7400398,
      bmsSoc: 0.7759940000000001,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '17801485971336608',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B18/Rack_04',
      accureSoc: 0.62961338,
      bmsSoc: 0.7413102,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '49077479741439416',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B18/Rack_05',
      accureSoc: 0.76305916,
      bmsSoc: 0.7589509,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '45129314086819167',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B18/Rack_06',
      accureSoc: 0.60122322,
      bmsSoc: 0.6617333999999999,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '6179717183598613',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B18/Rack_07',
      accureSoc: 0.7360952000000001,
      bmsSoc: 0.6036868,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '37367737864105152',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B18/Rack_08',
      accureSoc: 0.8037442,
      bmsSoc: 0.6905894,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '69588164753444757',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B18/Rack_09',
      accureSoc: 0.8084929,
      bmsSoc: 0.60685963,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '68228446603551146',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B18/Rack_10',
      accureSoc: 0.8230632,
      bmsSoc: 0.8745214,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '35411598728802570',
      type: AssetType.CONTAINER,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B19',
      accureSoc: 0.6931496340000001,
      bmsSoc: 0.7613724800000001,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '17284153773455137',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B19/Rack_01',
      accureSoc: 0.6948162000000001,
      bmsSoc: 0.6647735,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '48806938598024116',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B19/Rack_02',
      accureSoc: 0.7236253,
      bmsSoc: 0.862784,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '11986804017601896',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B19/Rack_03',
      accureSoc: 0.60890137,
      bmsSoc: 0.8047732000000001,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '61098197719043385',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B19/Rack_04',
      accureSoc: 0.60786907,
      bmsSoc: 0.807024,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '66184847427690058',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B19/Rack_05',
      accureSoc: 0.7056501000000001,
      bmsSoc: 0.6750648499999999,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '26575516861154073',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B19/Rack_06',
      accureSoc: 0.7239262399999999,
      bmsSoc: 0.89452774,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '34619842153783870',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B19/Rack_07',
      accureSoc: 0.741305,
      bmsSoc: 0.6878137,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '10040882121069437',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B19/Rack_08',
      accureSoc: 0.6587000000000001,
      bmsSoc: 0.63560097,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '60695585843713864',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B19/Rack_09',
      accureSoc: 0.6964889,
      bmsSoc: 0.81695244,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '26927875387232999',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Sunset_Plaza/B19/Rack_10',
      accureSoc: 0.77021416,
      bmsSoc: 0.7644104,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
  ],
  '34567': [
    {
      id: '3456701',
      type: AssetType.PCS,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/PCS_01',
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {},
    },
    {
      id: '3456702',
      type: AssetType.PCS,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/PCS_02',
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {},
    },
    {
      id: '3456703',
      type: AssetType.PCS,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/PCS_03',
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {},
    },
    {
      id: '3456704',
      type: AssetType.PCS,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/PCS_04',
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {},
    },
    {
      id: '3456705',
      type: AssetType.PCS,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/PCS_05',
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {},
    },
    {
      id: '3456706',
      type: AssetType.PCS,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/PCS_06',
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {},
    },
    {
      id: '3456707',
      type: AssetType.PCS,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/PCS_07',
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {},
    },
    {
      id: '3456708',
      type: AssetType.PCS,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/PCS_08',
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {},
    },
    {
      id: '3456709',
      type: AssetType.PCS,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/PCS_09',
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {},
    },
    {
      id: '3456710',
      type: AssetType.PCS,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/PCS_10',
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {},
    },
    {
      id: '3456711',
      type: AssetType.PCS,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/PCS_11',
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {},
    },
    {
      id: '3456712',
      type: AssetType.PCS,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/PCS_12',
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {},
    },
    {
      id: '3456713',
      type: AssetType.PCS,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/PCS_13',
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {},
    },
    {
      id: '3456714',
      type: AssetType.PCS,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/PCS_14',
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {},
    },
    {
      id: '3456715',
      type: AssetType.PCS,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/PCS_15',
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {},
    },
    {
      id: '3456716',
      type: AssetType.PCS,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/PCS_16',
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {},
    },
    {
      id: '3456717',
      type: AssetType.PCS,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/PCS_17',
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {},
    },
    {
      id: '3456718',
      type: AssetType.PCS,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/PCS_18',
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {},
    },
    {
      id: '3456719',
      type: AssetType.PCS,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/PCS_19',
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {},
    },
    {
      id: '3456720',
      type: AssetType.PCS,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/PCS_20',
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {},
    },
    {
      id: '3456721',
      type: AssetType.PCS,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/PCS_21',
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {},
    },
    {
      id: '3456722',
      type: AssetType.PCS,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/PCS_22',
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {},
    },
    {
      id: '3456723',
      type: AssetType.PCS,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/PCS_23',
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {},
    },
    {
      id: '3456724',
      type: AssetType.PCS,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/PCS_24',
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {},
    },
    {
      id: '68810249463363542',
      type: AssetType.CONTAINER,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B01',
      accureSoc: 0.4199313357142858,
      bmsSoc: 0.4664876357142857,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '44262786570105247',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B01/Rack_01',
      accureSoc: 0.35509464,
      bmsSoc: 0.39747436999999997,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '26905524237387724',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B01/Rack_02',
      accureSoc: 0.3574888,
      bmsSoc: 0.49899067,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '43266919750272151',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B01/Rack_03',
      accureSoc: 0.363521,
      bmsSoc: 0.51524853,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '59086561782369494',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B01/Rack_04',
      accureSoc: 0.4752832,
      bmsSoc: 0.5611773,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '4655539236530224',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B01/Rack_05',
      accureSoc: 0.46008857999999997,
      bmsSoc: 0.4660317,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '66684427417835148',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B01/Rack_06',
      accureSoc: 0.44619053000000003,
      bmsSoc: 0.41946068,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '44378986949131962',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B01/Rack_07',
      accureSoc: 0.4818526,
      bmsSoc: 0.4070302,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '26688779656110660',
      type: AssetType.CONTAINER,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B02',
      accureSoc: 0.4172836014285714,
      bmsSoc: 0.44729687999999995,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '6235619112861210',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B02/Rack_01',
      accureSoc: 0.44415222,
      bmsSoc: 0.5571815999999999,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '32005371243043353',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B02/Rack_02',
      accureSoc: 0.44046737999999996,
      bmsSoc: 0.42687103,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '65123223871815290',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B02/Rack_03',
      accureSoc: 0.4066592,
      bmsSoc: 0.41146160000000004,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '18568289531407894',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B02/Rack_04',
      accureSoc: 0.40568477999999997,
      bmsSoc: 0.4297229,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '7094469504664286',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B02/Rack_05',
      accureSoc: 0.3960575,
      bmsSoc: 0.42689053,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '36078247376804333',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B02/Rack_06',
      accureSoc: 0.4332188,
      bmsSoc: 0.39942005,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '36209438535110631',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B02/Rack_07',
      accureSoc: 0.39474533,
      bmsSoc: 0.47953045000000005,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '5208048146371065',
      type: AssetType.CONTAINER,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B03',
      accureSoc: 0.4052732628571429,
      bmsSoc: 0.4588518814285715,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '35318091892249771',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B03/Rack_01',
      accureSoc: 0.42294289999999995,
      bmsSoc: 0.40919829999999996,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '14107409534745415',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B03/Rack_02',
      accureSoc: 0.3642912,
      bmsSoc: 0.55149586,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '49734039780099825',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B03/Rack_03',
      accureSoc: 0.3540625,
      bmsSoc: 0.44018345,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '41650961282610639',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B03/Rack_04',
      accureSoc: 0.48159843,
      bmsSoc: 0.42840763000000004,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '62762969003009503',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B03/Rack_05',
      accureSoc: 0.38609074,
      bmsSoc: 0.48872770000000004,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '41265578664303445',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B03/Rack_06',
      accureSoc: 0.3700126,
      bmsSoc: 0.49130870000000004,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '52000826579640257',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B03/Rack_07',
      accureSoc: 0.45791446999999996,
      bmsSoc: 0.40264153,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '52095245272996909',
      type: AssetType.CONTAINER,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B04',
      accureSoc: 0.41398758999999996,
      bmsSoc: 0.47806170428571426,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '38659240387588959',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B04/Rack_01',
      accureSoc: 0.39141323,
      bmsSoc: 0.48054184,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '31333048061248156',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B04/Rack_02',
      accureSoc: 0.4015477,
      bmsSoc: 0.47108475,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '49447700021204043',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B04/Rack_03',
      accureSoc: 0.36120483,
      bmsSoc: 0.5586502,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '17141526905007658',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B04/Rack_04',
      accureSoc: 0.5099078,
      bmsSoc: 0.5347254,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '32434374897784146',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B04/Rack_05',
      accureSoc: 0.39254875,
      bmsSoc: 0.4964774,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '24277162998605119',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B04/Rack_06',
      accureSoc: 0.48001484,
      bmsSoc: 0.3853369,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '47209317785957315',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B04/Rack_07',
      accureSoc: 0.36127598,
      bmsSoc: 0.41961544000000006,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '62951201805066422',
      type: AssetType.CONTAINER,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B05',
      accureSoc: 0.4043972142857143,
      bmsSoc: 0.4571968385714286,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '61939568820839264',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B05/Rack_01',
      accureSoc: 0.3842024,
      bmsSoc: 0.42067256999999997,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '47907067275323195',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B05/Rack_02',
      accureSoc: 0.49256622,
      bmsSoc: 0.45505466,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '48526863698603864',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B05/Rack_03',
      accureSoc: 0.34976276,
      bmsSoc: 0.5585843,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '25250069974272448',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B05/Rack_04',
      accureSoc: 0.40914368,
      bmsSoc: 0.46996098000000003,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '5856479230073424',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B05/Rack_05',
      accureSoc: 0.4036921,
      bmsSoc: 0.39067333,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '20471540913518535',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B05/Rack_06',
      accureSoc: 0.34181587,
      bmsSoc: 0.45520443,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '50603710744382028',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B05/Rack_07',
      accureSoc: 0.44959747,
      bmsSoc: 0.4502276,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '42935953921198998',
      type: AssetType.CONTAINER,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B06',
      accureSoc: 0.4008137585714286,
      bmsSoc: 0.45583928,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '21633242953326513',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B06/Rack_01',
      accureSoc: 0.4221217,
      bmsSoc: 0.48282795,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '63716930169321346',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B06/Rack_02',
      accureSoc: 0.43621662,
      bmsSoc: 0.47337784,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '4337717586297350',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B06/Rack_03',
      accureSoc: 0.37235428,
      bmsSoc: 0.47167990000000004,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '1816065337026227',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B06/Rack_04',
      accureSoc: 0.3907604,
      bmsSoc: 0.55679733,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '23078986167548976',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B06/Rack_05',
      accureSoc: 0.41698334000000004,
      bmsSoc: 0.41386673,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '37061098950414129',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B06/Rack_06',
      accureSoc: 0.37384212,
      bmsSoc: 0.38970993,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '46039135135769811',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B06/Rack_07',
      accureSoc: 0.39341785,
      bmsSoc: 0.40261527999999996,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '54380859669690804',
      type: AssetType.CONTAINER,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B07',
      accureSoc: 0.4359434942857143,
      bmsSoc: 0.49948581857142854,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '56395827885335761',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B07/Rack_01',
      accureSoc: 0.48719273,
      bmsSoc: 0.54736797,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '68288132438534195',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B07/Rack_02',
      accureSoc: 0.42711803000000004,
      bmsSoc: 0.52139706,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '42520939806310753',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B07/Rack_03',
      accureSoc: 0.3424117,
      bmsSoc: 0.44866276,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '14659260481768716',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B07/Rack_04',
      accureSoc: 0.37637383,
      bmsSoc: 0.55661495,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '9308028791642601',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B07/Rack_05',
      accureSoc: 0.46956017000000005,
      bmsSoc: 0.48180073,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '42580670235822364',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B07/Rack_06',
      accureSoc: 0.457213,
      bmsSoc: 0.45927986,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '7037076435548809',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B07/Rack_07',
      accureSoc: 0.491735,
      bmsSoc: 0.4812774,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '55999870768132519',
      type: AssetType.CONTAINER,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B08',
      accureSoc: 0.42233064571428564,
      bmsSoc: 0.45105922,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '2538918863590415',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B08/Rack_01',
      accureSoc: 0.34677329999999995,
      bmsSoc: 0.5371507600000001,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '36828021029146421',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B08/Rack_02',
      accureSoc: 0.4241416,
      bmsSoc: 0.44779865,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '51461022411741932',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B08/Rack_03',
      accureSoc: 0.49394129999999997,
      bmsSoc: 0.46501457,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '62334855922460872',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B08/Rack_04',
      accureSoc: 0.47602562,
      bmsSoc: 0.45023552,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '25139187188403141',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B08/Rack_05',
      accureSoc: 0.3838061,
      bmsSoc: 0.43784664,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '59702983162494328',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B08/Rack_06',
      accureSoc: 0.3735719,
      bmsSoc: 0.42717644,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '25492131571971810',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B08/Rack_07',
      accureSoc: 0.4580547,
      bmsSoc: 0.39219195999999995,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '17590262253897322',
      type: AssetType.CONTAINER,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B09',
      accureSoc: 0.4218950916666667,
      bmsSoc: 0.4739497366666667,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '7768783131568285',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B09/Rack_01',
      accureSoc: 0.41597656,
      bmsSoc: 0.51651657,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '25163592552586681',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B09/Rack_02',
      accureSoc: 0.36847057,
      bmsSoc: 0.39916739999999995,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '26613609825343367',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B09/Rack_03',
      accureSoc: 0.4996081,
      bmsSoc: 0.48485004000000004,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '28253986343896803',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B09/Rack_04',
      accureSoc: 0.3823982,
      bmsSoc: 0.43685265,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '31090759195636136',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B09/Rack_05',
      accureSoc: 0.4675839,
      bmsSoc: 0.53069702,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '67340213169365601',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B09/Rack_06',
      accureSoc: 0.39733322,
      bmsSoc: 0.47561474,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '51937854157168776',
      type: AssetType.CONTAINER,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B10',
      accureSoc: 0.4270725566666666,
      bmsSoc: 0.50091147,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '11158484892686668',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B10/Rack_01',
      accureSoc: 0.48129157999999994,
      bmsSoc: 0.55859257,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '68927473038752950',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B10/Rack_02',
      accureSoc: 0.44754089999999996,
      bmsSoc: 0.47871735,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '50436436145897532',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B10/Rack_03',
      accureSoc: 0.4674029,
      bmsSoc: 0.41794020000000004,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '39820713219009219',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B10/Rack_04',
      accureSoc: 0.3963086,
      bmsSoc: 0.53063442,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '49339515477753697',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B10/Rack_05',
      accureSoc: 0.35669003,
      bmsSoc: 0.46923668,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '28724523743614418',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B10/Rack_06',
      accureSoc: 0.41320133,
      bmsSoc: 0.5503475999999999,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '90998129563161',
      type: AssetType.CONTAINER,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B11',
      accureSoc: 0.4557126733333333,
      bmsSoc: 0.43646312833333334,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '13376914750853058',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B11/Rack_01',
      accureSoc: 0.46623833,
      bmsSoc: 0.3802442,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '56841109492578227',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B11/Rack_02',
      accureSoc: 0.38737362,
      bmsSoc: 0.40334587,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '10946992763985964',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B11/Rack_03',
      accureSoc: 0.47263443000000005,
      bmsSoc: 0.5357096,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '35323450106053539',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B11/Rack_04',
      accureSoc: 0.4941706,
      bmsSoc: 0.41271680000000005,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '3521236114852592',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B11/Rack_05',
      accureSoc: 0.40271164,
      bmsSoc: 0.4624849,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '13008081726865069',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B11/Rack_06',
      accureSoc: 0.51114742,
      bmsSoc: 0.4242774,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '20240335320536014',
      type: AssetType.CONTAINER,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B12',
      accureSoc: 0.438897355,
      bmsSoc: 0.4935672950000001,
      alertStatus: AlertStatus.WARNING,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '49552413449274128',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B12/Rack_01',
      accureSoc: 0.4816144,
      bmsSoc: 0.54865715,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '30191853110409596',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B12/Rack_02',
      accureSoc: 0.4059912,
      bmsSoc: 0.52296646,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '28070762464680969',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B12/Rack_03',
      accureSoc: 0.38247486,
      bmsSoc: 0.42566895000000005,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '69832781860857833',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B12/Rack_04',
      accureSoc: 0.43620486999999997,
      bmsSoc: 0.43717350000000005,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '22891281137356005',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B12/Rack_05',
      accureSoc: 0.45343269999999997,
      bmsSoc: 0.54870056,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '32052106622291805',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B12/Rack_06',
      accureSoc: 0.47366610000000003,
      bmsSoc: 0.47823715,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '20859898438017379',
      type: AssetType.CONTAINER,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B13',
      accureSoc: 0.43886261857142855,
      bmsSoc: 0.45676377714285704,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '38113168415355033',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B13/Rack_01',
      accureSoc: 0.36428119999999997,
      bmsSoc: 0.48329464,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '14302806928450382',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B13/Rack_02',
      accureSoc: 0.44355530000000004,
      bmsSoc: 0.5572676,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '62376281187427261',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B13/Rack_03',
      accureSoc: 0.4727509,
      bmsSoc: 0.38984745,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '17255494565430446',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B13/Rack_04',
      accureSoc: 0.45682870000000003,
      bmsSoc: 0.3987545,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '7023040110786477',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B13/Rack_05',
      accureSoc: 0.37004604,
      bmsSoc: 0.4329518,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '26764239342805376',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B13/Rack_06',
      accureSoc: 0.48114445000000006,
      bmsSoc: 0.5401363,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '30553784399725380',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B13/Rack_07',
      accureSoc: 0.48343174,
      bmsSoc: 0.39509415,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '7968654005981071',
      type: AssetType.CONTAINER,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B14',
      accureSoc: 0.4460075485714286,
      bmsSoc: 0.49916653285714285,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '47066440660800271',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B14/Rack_01',
      accureSoc: 0.47227753,
      bmsSoc: 0.53796154,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '13412229836202362',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B14/Rack_02',
      accureSoc: 0.4357019,
      bmsSoc: 0.45767365,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '3602344568108499',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B14/Rack_03',
      accureSoc: 0.42991799999999997,
      bmsSoc: 0.42173927,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '44577104628557354',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B14/Rack_04',
      accureSoc: 0.4742716,
      bmsSoc: 0.5301494999999999,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '30492556676042766',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B14/Rack_05',
      accureSoc: 0.42174744,
      bmsSoc: 0.50824787,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '70071017920417767',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B14/Rack_06',
      accureSoc: 0.46476612,
      bmsSoc: 0.50319435,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '33143413568738102',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B14/Rack_07',
      accureSoc: 0.42337024999999995,
      bmsSoc: 0.5351995500000001,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '28520624921613308',
      type: AssetType.CONTAINER,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B15',
      accureSoc: 0.43818779999999996,
      bmsSoc: 0.4719447757142858,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '21653856199572797',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B15/Rack_01',
      accureSoc: 0.5019572999999999,
      bmsSoc: 0.4451062,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '27365264825782934',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B15/Rack_02',
      accureSoc: 0.4307541,
      bmsSoc: 0.54072746,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '63557573616345587',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B15/Rack_03',
      accureSoc: 0.38236145,
      bmsSoc: 0.50488537,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '23181206242594511',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B15/Rack_04',
      accureSoc: 0.48273955999999996,
      bmsSoc: 0.4727131,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '62480409727017366',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B15/Rack_05',
      accureSoc: 0.41103206999999997,
      bmsSoc: 0.397219,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '14158364375943252',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B15/Rack_06',
      accureSoc: 0.42119072,
      bmsSoc: 0.42528309999999997,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '11314509918393158',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B15/Rack_07',
      accureSoc: 0.4372794,
      bmsSoc: 0.5176792,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '14397688147389146',
      type: AssetType.CONTAINER,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B16',
      accureSoc: 0.43092067,
      bmsSoc: 0.48172195,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '17178712120278320',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B16/Rack_01',
      accureSoc: 0.41189079999999995,
      bmsSoc: 0.5421937,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '26682097369265135',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B16/Rack_02',
      accureSoc: 0.37721153,
      bmsSoc: 0.5490373199999999,
      alertStatus: AlertStatus.INFO,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '23166424732939833',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B16/Rack_03',
      accureSoc: 0.4312175,
      bmsSoc: 0.38257336000000003,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '52378953485546685',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B16/Rack_04',
      accureSoc: 0.41637189999999996,
      bmsSoc: 0.5104204,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '17927613245815604',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B16/Rack_05',
      accureSoc: 0.48480114,
      bmsSoc: 0.3904862,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '65784297568105507',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B16/Rack_06',
      accureSoc: 0.42397877,
      bmsSoc: 0.5461798,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '8656234036716442',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B16/Rack_07',
      accureSoc: 0.47097305,
      bmsSoc: 0.45116287,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '4973799425202413',
      type: AssetType.CONTAINER,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B17',
      accureSoc: 0.44062989,
      bmsSoc: 0.4897969042857143,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '10110088247115396',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B17/Rack_01',
      accureSoc: 0.46547710000000003,
      bmsSoc: 0.41416203,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '2053692546559302',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B17/Rack_02',
      accureSoc: 0.47498383,
      bmsSoc: 0.50874054,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '70581178585199271',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B17/Rack_03',
      accureSoc: 0.34793391999999995,
      bmsSoc: 0.5354466,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '52500410976540328',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B17/Rack_04',
      accureSoc: 0.4653965,
      bmsSoc: 0.5373528000000001,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '24956673337015736',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B17/Rack_05',
      accureSoc: 0.48798233,
      bmsSoc: 0.46772030000000003,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '35910466305307305',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B17/Rack_06',
      accureSoc: 0.38844135,
      bmsSoc: 0.41961371999999997,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '32300504484497934',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B17/Rack_07',
      accureSoc: 0.45419420000000005,
      bmsSoc: 0.54554234,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '70720494449034970',
      type: AssetType.CONTAINER,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B18',
      accureSoc: 0.4559289614285715,
      bmsSoc: 0.4746988614285715,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '50619950495859730',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B18/Rack_01',
      accureSoc: 0.494867,
      bmsSoc: 0.39814735,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '38645722419021758',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B18/Rack_02',
      accureSoc: 0.4325764,
      bmsSoc: 0.5458244,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '28862791299318153',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B18/Rack_03',
      accureSoc: 0.36971485000000004,
      bmsSoc: 0.45458496,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '45065540055841262',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B18/Rack_04',
      accureSoc: 0.5068422,
      bmsSoc: 0.4178546,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '38070773761938067',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B18/Rack_05',
      accureSoc: 0.44330939999999996,
      bmsSoc: 0.45242016,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '63722519976061634',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B18/Rack_06',
      accureSoc: 0.44253918,
      bmsSoc: 0.5051783,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '52481637789387812',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B18/Rack_07',
      accureSoc: 0.5016537,
      bmsSoc: 0.5488822600000001,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '52453168776388276',
      type: AssetType.CONTAINER,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B19',
      accureSoc: 0.46659859714285723,
      bmsSoc: 0.49535683999999996,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '48688770396985074',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B19/Rack_01',
      accureSoc: 0.46225360000000004,
      bmsSoc: 0.4119737,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '14460835168906315',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B19/Rack_02',
      accureSoc: 0.43624454,
      bmsSoc: 0.5390199,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '52998696880078229',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B19/Rack_03',
      accureSoc: 0.50508453,
      bmsSoc: 0.52929626,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '31443814677279121',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B19/Rack_04',
      accureSoc: 0.47271680000000005,
      bmsSoc: 0.3906475,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '49265051464892748',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B19/Rack_05',
      accureSoc: 0.48580627,
      bmsSoc: 0.5155275,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '38695840649889281',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B19/Rack_06',
      accureSoc: 0.40181187,
      bmsSoc: 0.55990612,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '1495526027727418',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B19/Rack_07',
      accureSoc: 0.50227257,
      bmsSoc: 0.5211269000000001,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '65006415899326271',
      type: AssetType.CONTAINER,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B20',
      accureSoc: 0.4211378514285714,
      bmsSoc: 0.4759352457142858,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '48971081830872427',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B20/Rack_01',
      accureSoc: 0.4420606,
      bmsSoc: 0.5377386,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '48757661508021137',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B20/Rack_02',
      accureSoc: 0.47765396000000004,
      bmsSoc: 0.52688046,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '4809815686882139',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B20/Rack_03',
      accureSoc: 0.37316130000000003,
      bmsSoc: 0.44708145,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '48860916300418370',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B20/Rack_04',
      accureSoc: 0.44715815999999997,
      bmsSoc: 0.38144077000000004,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '7158730309284118',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B20/Rack_05',
      accureSoc: 0.427933,
      bmsSoc: 0.5202669,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '45886904170386958',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B20/Rack_06',
      accureSoc: 0.36472164,
      bmsSoc: 0.4574337,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '41779508507157494',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B20/Rack_07',
      accureSoc: 0.41527630000000004,
      bmsSoc: 0.46070484,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '4671598442638018',
      type: AssetType.CONTAINER,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B21',
      accureSoc: 0.402917605,
      bmsSoc: 0.45342787166666676,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '49858423950880505',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B21/Rack_01',
      accureSoc: 0.34947432999999994,
      bmsSoc: 0.45443783000000004,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '46870689238557165',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B21/Rack_02',
      accureSoc: 0.3433305,
      bmsSoc: 0.4697677,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '40768168588328948',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B21/Rack_03',
      accureSoc: 0.37977287,
      bmsSoc: 0.4743307,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '56563756851894281',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B21/Rack_04',
      accureSoc: 0.41193244999999995,
      bmsSoc: 0.41694138000000003,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '63486783724460205',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B21/Rack_05',
      accureSoc: 0.4374832,
      bmsSoc: 0.452665,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '17145910332195513',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B21/Rack_06',
      accureSoc: 0.49551228,
      bmsSoc: 0.45242462000000006,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '2612182939287076',
      type: AssetType.CONTAINER,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B22',
      accureSoc: 0.45011174333333337,
      bmsSoc: 0.491302435,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '53382178548989907',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B22/Rack_01',
      accureSoc: 0.47893112000000004,
      bmsSoc: 0.50754917,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '71499463918202387',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B22/Rack_02',
      accureSoc: 0.39550358,
      bmsSoc: 0.4054513,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '34365075744484327',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B22/Rack_03',
      accureSoc: 0.4962856,
      bmsSoc: 0.45760787999999997,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '70713094701696135',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B22/Rack_04',
      accureSoc: 0.4618311,
      bmsSoc: 0.5589812,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '35413507095972812',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B22/Rack_05',
      accureSoc: 0.4357871,
      bmsSoc: 0.47467434,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '30429192677332961',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B22/Rack_06',
      accureSoc: 0.43233196,
      bmsSoc: 0.54355072,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '25931767534931922',
      type: AssetType.CONTAINER,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B23',
      accureSoc: 0.44552358500000006,
      bmsSoc: 0.49465981166666667,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '48252989460899083',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B23/Rack_01',
      accureSoc: 0.3595805,
      bmsSoc: 0.5179654699999999,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '6489621000364283',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B23/Rack_02',
      accureSoc: 0.43659653,
      bmsSoc: 0.43204810000000005,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '65365547490194511',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B23/Rack_03',
      accureSoc: 0.4972462,
      bmsSoc: 0.5427126,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '60789031339525557',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B23/Rack_04',
      accureSoc: 0.50440502,
      bmsSoc: 0.44917454,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '32266837888722812',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B23/Rack_05',
      accureSoc: 0.37863342000000005,
      bmsSoc: 0.52832546,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '27329678242489183',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B23/Rack_06',
      accureSoc: 0.49667984,
      bmsSoc: 0.4977327,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '12521425487257130',
      type: AssetType.CONTAINER,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B24',
      accureSoc: 0.4042971716666667,
      bmsSoc: 0.4287774383333333,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '19444713267498720',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B24/Rack_01',
      accureSoc: 0.39693745,
      bmsSoc: 0.4253421,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '2094862441585329',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B24/Rack_02',
      accureSoc: 0.40948036000000004,
      bmsSoc: 0.4129836,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '53965937023473965',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B24/Rack_03',
      accureSoc: 0.36685158,
      bmsSoc: 0.37888120000000003,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '71460987189680773',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B24/Rack_04',
      accureSoc: 0.42185898,
      bmsSoc: 0.5387214300000001,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '27728366972216984',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B24/Rack_05',
      accureSoc: 0.41265026,
      bmsSoc: 0.4053219,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
    {
      id: '48444700418667565',
      type: AssetType.RACK,
      frontendId: '',
      fullFrontendId: 'Smart_Hill/B24/Rack_06',
      accureSoc: 0.4180044,
      bmsSoc: 0.4114144,
      alertStatus: AlertStatus.OK,
      nbOpenTasks: 0,
      metadata: {
        capacity: 1000,
        cellChemistry: 'LFP',
        cellType: 'Celltypeb',
        deviceType: 'Unittypeb',
        manufacturer: 'Manufacturerx',
      },
    },
  ],
};
